


import MenuEn from './en/MenuEn';
import MenuEs from './es/MenuEs';
import MenuRu from './ru/MenuRu';
import HomeEn from './en/HomeEn';
import HomeEs from './es/HomeEs';
import HomeRu from './ru/HomeRu';
import AboutEn from './en/AboutEn';
import AboutEs from './es/AboutEs';
import AboutRu from './ru/AboutRu';
import ContactEn from './en/ContactEn';
import ContactEs from './es/ContactEs';
import ContactRu from './ru/ContactRu';
import SupportEn from './en/SupportEn';
import SupportEs from './es/SupportEs';
import SupportRu from './ru/SupportRu';

import PruebaEs from './es/aPruebaEs';
import BlogDetailsEs from './es/BlogDetailsEs';
import CategoryEs from './es/CategoryEs';

import EventsCultureEn from './en/EventsCultureEn';
import EventsCultureEs from './es/EventsCultureEs';
import EventsCultureRu from './ru/EventsCultureRu';
import EventsDanceEn from './en/EventsDanceEn';
import EventsDanceEs from './es/EventsDanceEs';
import EventsDanceRu from './ru/EventsDanceRu';
import EventSpanishEn from './en/EventSpanishEn';
import EventSpanishEs from './es/EventSpanishEs';
import EventSpanishRu from './ru/EventSpanishRu';
import GalleryEn from './en/GalleryEn';
import GalleryEs from './es/GalleryEs';
import GalleryRu from './ru/GalleryRu';
import PhotosEn from './en/PhotosEn';
import PhotosEs from './es/PhotosEs';
import PhotosRu from './ru/PhotosRu';
import ProjectsEn from './en/ProjectsEn';
import ProjectsEs from './es/ProjectsEs';
import ProjectsRu from './ru/ProjectsRu';

import RestaHomeEn from './en/RestaHomeEn';
import RestaHomeEs from './es/RestaHomeEs';
import RestaHomeRu from './ru/RestaHomeRu';

import SpanishLanguageEn from './en/WebuniEn';
import SpanishLanguageEs from './es/WebuniEs';
import SpanishLanguageRu from './ru/WebuniRu';
import SchoolsDanceEn from './en/SchoolsDanceEn';
import SchoolsDanceEs from './es/SchoolsDanceEs';
import SchoolsDanceRu from './ru/SchoolsDanceRu';
import SchoolsSpanishEn from './en/SchoolsSpanishEn';
import SchoolsSpanishEs from './es/SchoolsSpanishEs';
import SchoolsSpanishRu from './ru/SchoolsSpanishRu';
import StoreEn from './en/StoreEn';
import StoreEs from './es/StoreEs';
import StoreRu from './ru/StoreRu';
import TeachersDanceEn from './en/TeachersDanceEn';
import TeachersDanceEs from './es/TeachersDanceEs';
import TeachersDanceRu from './ru/TeachersDanceRu';
import TeacherSpanishEn from './en/TeacherSpanishEn';
import TeacherSpanishEs from './es/TeacherSpanishEs';
import TeacherSpanishRu from './ru/TeacherSpanishRu';
import VideoEventsEn from './en/VideoEventsEn';
import VideoEventsEs from './es/VideoEventsEs';
import VideoEventsRu from './ru/VideoEventsRu';


import TurizoLaBachataEs from '../pages/es/lyrics/TurizoLaBachataEs';
import TurizoLaBachataRu from '../pages/ru/lyrics/TurizoLaBachataRu';
import LatinoDanceMoscowEn from '../pages/en/lifestyle/231228En-latino-dance-in-Moscow';
import LatinoDanceMoscowEs from '../pages/es/lifestyle/231228Es-latino-dance-in-Moscow';
import LatinoDanceMoscowRu from '../pages/ru/lifestyle/231228Ru-latino-dance-in-Moscow';
import TravelToSpainEs from '../pages/es/travel/231228Es-travel-spain';
import TravelToSpainRu from '../pages/ru/travel/231228Ru-travel-spain';
import NewYearLatamEs from '../pages/es/society/231228Es-new-year-latam';
import NewYearLatamRu from '../pages/ru/society/231228Ru-new-year-latam';
import OpenAirMoscowEn from '../pages/en/lifestyle/240506En-open-air-in-Moscow';
import OpenAirMoscowEs from '../pages/es/lifestyle/240506Es-open-air-in-Moscow';
import OpenAirMoscowRu from '../pages/ru/lifestyle/240506Ru-open-air-in-Moscow';  
import LatinaFestMoscowEn from '../pages/en/lifestyle/240716En-latina-fest-Moscow';
import LatinaFestMoscowEs from '../pages/es/lifestyle/240716Es-latina-fest-Moscow';
import LatinaFestMoscowRu from '../pages/ru/lifestyle/240716Ru-latina-fest-Moscow';
import SalsatecaEn from '../pages/en/schdance/240611En-salsateca';
import SalsatecaEs from '../pages/es/schdance/240611Es-salsateca';
import SalsatecaRu from '../pages/ru/schdance/240611Ru-salsateca';

import Photo240509En from '../pages/en/photo/PhotoEn-240509';
import Photo240509Es from '../pages/es/photo/PhotoEs-240509';
import Photo240509Ru from '../pages/ru/photo/PhotoRu-240509';
import StoreAlpacaEn from '../pages/en/photo/PhotoGalleryAlpacaEn';
import StoreAlpacaEs from '../pages/es/photo/PhotoGalleryAlpacaEs';
import StoreAlpacaRu from '../pages/ru/photo/PhotoGalleryAlpacaRu';
import StorePeruEn from '../pages/en/photo/PhotoStorePeruEn';
import StorePeruEs from '../pages/es/photo/PhotoStorePeruEs';
import StorePeruRu from '../pages/ru/photo/PhotoStorePeruRu';

import VideoOpen240518En from '../pages/en/avideo/VideoEn-Open240518';
import VideoOpen240518Es from '../pages/es/avideo/VideoEs-Open240518';
import VideoOpen240518Ru from '../pages/ru/avideo/VideoRu-Open240518';
import VideoOpen240519En from '../pages/en/avideo/VideoEn-Open240519';
import VideoOpen240519Es from '../pages/es/avideo/VideoEs-Open240519';
import VideoOpen240519Ru from '../pages/ru/avideo/VideoRu-Open240519';
import VideoOpen240525En from '../pages/en/avideo/VideoEn-Open240525';
import VideoOpen240525Es from '../pages/es/avideo/VideoEs-Open240525';
import VideoOpen240525Ru from '../pages/ru/avideo/VideoRu-Open240525';
import VideoOpen240528En from '../pages/en/avideo/VideoEn-Open240528';
import VideoOpen240528Es from '../pages/es/avideo/VideoEs-Open240528';
import VideoOpen240528Ru from '../pages/ru/avideo/VideoRu-Open240528';
import VideoOpen240530En from '../pages/en/avideo/VideoEn-Open240530';
import VideoOpen240530Es from '../pages/es/avideo/VideoEs-Open240530';
import VideoOpen240530Ru from '../pages/ru/avideo/VideoRu-Open240530';
import VideoOpen240531En from '../pages/en/avideo/VideoEn-Open240531';
import VideoOpen240531Es from '../pages/es/avideo/VideoEs-Open240531';
import VideoOpen240531Ru from '../pages/ru/avideo/VideoRu-Open240531';
import VideoOpen240602En from '../pages/en/avideo/VideoEn-Open240602';
import VideoOpen240602Es from '../pages/es/avideo/VideoEs-Open240602';
import VideoOpen240602Ru from '../pages/ru/avideo/VideoRu-Open240602';
import VideoOpen240607En from '../pages/en/avideo/VideoEn-Open240607';
import VideoOpen240607Es from '../pages/es/avideo/VideoEs-Open240607';
import VideoOpen240607Ru from '../pages/ru/avideo/VideoRu-Open240607';
import VideoOpen240608En from '../pages/en/avideo/VideoEn-Open240608';
import VideoOpen240608Es from '../pages/es/avideo/VideoEs-Open240608';
import VideoOpen240608Ru from '../pages/ru/avideo/VideoRu-Open240608';
import VideoOpen240609En from '../pages/en/avideo/VideoEn-Open240609';
import VideoOpen240609Es from '../pages/es/avideo/VideoEs-Open240609';
import VideoOpen240609Ru from '../pages/ru/avideo/VideoRu-Open240609';
import VideoOpen240614En from '../pages/en/avideo/VideoEn-Open240614';
import VideoOpen240614Es from '../pages/es/avideo/VideoEs-Open240614';
import VideoOpen240614Ru from '../pages/ru/avideo/VideoRu-Open240614';
import VideoOpen240615En from '../pages/en/avideo/VideoEn-Open240615';
import VideoOpen240615Es from '../pages/es/avideo/VideoEs-Open240615';
import VideoOpen240615Ru from '../pages/ru/avideo/VideoRu-Open240615';
import VideoOpen240616En from '../pages/en/avideo/VideoEn-Open240616';
import VideoOpen240616Es from '../pages/es/avideo/VideoEs-Open240616';
import VideoOpen240616Ru from '../pages/ru/avideo/VideoRu-Open240616';
import VideoOpen240619En from '../pages/en/avideo/VideoEn-Open240619';
import VideoOpen240619Es from '../pages/es/avideo/VideoEs-Open240619';
import VideoOpen240619Ru from '../pages/ru/avideo/VideoRu-Open240619';
import VideoOpen240621En from '../pages/en/avideo/VideoEn-Open240621';
import VideoOpen240621Es from '../pages/es/avideo/VideoEs-Open240621';
import VideoOpen240621Ru from '../pages/ru/avideo/VideoRu-Open240621';
import VideoOpen240622En from '../pages/en/avideo/VideoEn-Open240622';
import VideoOpen240622Es from '../pages/es/avideo/VideoEs-Open240622';
import VideoOpen240622Ru from '../pages/ru/avideo/VideoRu-Open240622';
import VideoOpen240623En from '../pages/en/avideo/VideoEn-Open240623';
import VideoOpen240623Es from '../pages/es/avideo/VideoEs-Open240623';
import VideoOpen240623Ru from '../pages/ru/avideo/VideoRu-Open240623';
import VideoOpen240625En from '../pages/en/avideo/VideoEn-Open240625';
import VideoOpen240625Es from '../pages/es/avideo/VideoEs-Open240625';
import VideoOpen240625Ru from '../pages/ru/avideo/VideoRu-Open240625';
import VideoOpen240626En from '../pages/en/avideo/VideoEn-Open240626';
import VideoOpen240626Es from '../pages/es/avideo/VideoEs-Open240626';
import VideoOpen240626Ru from '../pages/ru/avideo/VideoRu-Open240626';
import VideoOpen240628En from '../pages/en/avideo/VideoEn-Open240628';
import VideoOpen240628Es from '../pages/es/avideo/VideoEs-Open240628';
import VideoOpen240628Ru from '../pages/ru/avideo/VideoRu-Open240628';
import VideoOpen240629En from '../pages/en/avideo/VideoEn-Open240629';
import VideoOpen240629Es from '../pages/es/avideo/VideoEs-Open240629';
import VideoOpen240629Ru from '../pages/ru/avideo/VideoRu-Open240629';
import VideoOpen240630En from '../pages/en/avideo/VideoEn-Open240630';
import VideoOpen240630Es from '../pages/es/avideo/VideoEs-Open240630';
import VideoOpen240630Ru from '../pages/ru/avideo/VideoRu-Open240630';
import VideoOpen240701En from '../pages/en/avideo/VideoEn-Open240701';
import VideoOpen240701Es from '../pages/es/avideo/VideoEs-Open240701';
import VideoOpen240701Ru from '../pages/ru/avideo/VideoRu-Open240701';
import VideoOpen240702En from '../pages/en/avideo/VideoEn-Open240702';
import VideoOpen240702Es from '../pages/es/avideo/VideoEs-Open240702';
import VideoOpen240702Ru from '../pages/ru/avideo/VideoRu-Open240702';
import VideoOpen240703En from '../pages/en/avideo/VideoEn-Open240703';
import VideoOpen240703Es from '../pages/es/avideo/VideoEs-Open240703';
import VideoOpen240703Ru from '../pages/ru/avideo/VideoRu-Open240703';
import VideoOpen240706En from '../pages/en/avideo/VideoEn-Open240706';
import VideoOpen240706Es from '../pages/es/avideo/VideoEs-Open240706';
import VideoOpen240706Ru from '../pages/ru/avideo/VideoRu-Open240706';
import VideoOpen240707En from '../pages/en/avideo/VideoEn-Open240707';
import VideoOpen240707Es from '../pages/es/avideo/VideoEs-Open240707';
import VideoOpen240707Ru from '../pages/ru/avideo/VideoRu-Open240707';
import VideoOpen240709En from '../pages/en/avideo/VideoEn-Open240709';
import VideoOpen240709Es from '../pages/es/avideo/VideoEs-Open240709';
import VideoOpen240709Ru from '../pages/ru/avideo/VideoRu-Open240709';
import VideoOpen240710En from '../pages/en/avideo/VideoEn-Open240710';
import VideoOpen240710Es from '../pages/es/avideo/VideoEs-Open240710';
import VideoOpen240710Ru from '../pages/ru/avideo/VideoRu-Open240710';
import VideoOpen240712En from '../pages/en/avideo/VideoEn-Open240712';
import VideoOpen240712Es from '../pages/es/avideo/VideoEs-Open240712';
import VideoOpen240712Ru from '../pages/ru/avideo/VideoRu-Open240712';
import VideoOpen240713En from '../pages/en/avideo/VideoEn-Open240713';
import VideoOpen240713Es from '../pages/es/avideo/VideoEs-Open240713';
import VideoOpen240713Ru from '../pages/ru/avideo/VideoRu-Open240713';
import VideoOpen240714En from '../pages/en/avideo/VideoEn-Open240714';
import VideoOpen240714Es from '../pages/es/avideo/VideoEs-Open240714';
import VideoOpen240714Ru from '../pages/ru/avideo/VideoRu-Open240714';
import VideoOpen240716En from '../pages/en/avideo/VideoEn-Open240716';
import VideoOpen240716Es from '../pages/es/avideo/VideoEs-Open240716';
import VideoOpen240716Ru from '../pages/ru/avideo/VideoRu-Open240716';
import VideoOpen240717En from '../pages/en/avideo/VideoEn-Open240717';
import VideoOpen240717Es from '../pages/es/avideo/VideoEs-Open240717';
import VideoOpen240717Ru from '../pages/ru/avideo/VideoRu-Open240717'; 
import VideoOpen240718En from '../pages/en/avideo/VideoEn-Open240718';
import VideoOpen240718Es from '../pages/es/avideo/VideoEs-Open240718';
import VideoOpen240718Ru from '../pages/ru/avideo/VideoRu-Open240718';   
import VideoOpen240719En from '../pages/en/avideo/VideoEn-Open240719';
import VideoOpen240719Es from '../pages/es/avideo/VideoEs-Open240719';
import VideoOpen240719Ru from '../pages/ru/avideo/VideoRu-Open240719'; 
import VideoOpen240720En from '../pages/en/avideo/VideoEn-Open240720';
import VideoOpen240720Es from '../pages/es/avideo/VideoEs-Open240720';
import VideoOpen240720Ru from '../pages/ru/avideo/VideoRu-Open240720'; 
import VideoOpen240723En from '../pages/en/avideo/VideoEn-Open240723';
import VideoOpen240723Es from '../pages/es/avideo/VideoEs-Open240723';
import VideoOpen240723Ru from '../pages/ru/avideo/VideoRu-Open240723';
import VideoOpen240725En from '../pages/en/avideo/VideoEn-Open240725';
import VideoOpen240725Es from '../pages/es/avideo/VideoEs-Open240725';
import VideoOpen240725Ru from '../pages/ru/avideo/VideoRu-Open240725';
import VideoOpen240731En from '../pages/en/avideo/VideoEn-Open240731';
import VideoOpen240731Es from '../pages/es/avideo/VideoEs-Open240731';
import VideoOpen240731Ru from '../pages/ru/avideo/VideoRu-Open240731';
import VideoOpen240801En from '../pages/en/avideo/VideoEn-Open240801';
import VideoOpen240801Es from '../pages/es/avideo/VideoEs-Open240801';
import VideoOpen240801Ru from '../pages/ru/avideo/VideoRu-Open240801';
import VideoOpen240802En from '../pages/en/avideo/VideoEn-Open240802';
import VideoOpen240802Es from '../pages/es/avideo/VideoEs-Open240802';
import VideoOpen240802Ru from '../pages/ru/avideo/VideoRu-Open240802';
import VideoOpen240803En from '../pages/en/avideo/VideoEn-Open240803';
import VideoOpen240803Es from '../pages/es/avideo/VideoEs-Open240803';
import VideoOpen240803Ru from '../pages/ru/avideo/VideoRu-Open240803';
import VideoOpen240804En from '../pages/en/avideo/VideoEn-Open240804';
import VideoOpen240804Es from '../pages/es/avideo/VideoEs-Open240804';
import VideoOpen240804Ru from '../pages/ru/avideo/VideoRu-Open240804';
import VideoOpen240806En from '../pages/en/avideo/VideoEn-Open240806';
import VideoOpen240806Es from '../pages/es/avideo/VideoEs-Open240806';
import VideoOpen240806Ru from '../pages/ru/avideo/VideoRu-Open240806';
import VideoOpen240807En from '../pages/en/avideo/VideoEn-Open240807';
import VideoOpen240807Es from '../pages/es/avideo/VideoEs-Open240807';
import VideoOpen240807Ru from '../pages/ru/avideo/VideoRu-Open240807';
import VideoOpen240808En from '../pages/en/avideo/VideoEn-Open240808';
import VideoOpen240808Es from '../pages/es/avideo/VideoEs-Open240808';
import VideoOpen240808Ru from '../pages/ru/avideo/VideoRu-Open240808';
import VideoOpen240809En from '../pages/en/avideo/VideoEn-Open240809';
import VideoOpen240809Es from '../pages/es/avideo/VideoEs-Open240809';
import VideoOpen240809Ru from '../pages/ru/avideo/VideoRu-Open240809';
import VideoOpen240810En from '../pages/en/avideo/VideoEn-Open240810';
import VideoOpen240810Es from '../pages/es/avideo/VideoEs-Open240810';
import VideoOpen240810Ru from '../pages/ru/avideo/VideoRu-Open240810';
import VideoOpen240813En from '../pages/en/avideo/VideoEn-Open240813';
import VideoOpen240813Es from '../pages/es/avideo/VideoEs-Open240813';
import VideoOpen240813Ru from '../pages/ru/avideo/VideoRu-Open240813';
import VideoOpen240814En from '../pages/en/avideo/VideoEn-Open240814';
import VideoOpen240814Es from '../pages/es/avideo/VideoEs-Open240814';
import VideoOpen240814Ru from '../pages/ru/avideo/VideoRu-Open240814';
import VideoOpen240815En from '../pages/en/avideo/VideoEn-Open240815';
import VideoOpen240815Es from '../pages/es/avideo/VideoEs-Open240815';
import VideoOpen240815Ru from '../pages/ru/avideo/VideoRu-Open240815';
import VideoOpen240816En from '../pages/en/avideo/VideoEn-Open240816';
import VideoOpen240816Es from '../pages/es/avideo/VideoEs-Open240816';
import VideoOpen240816Ru from '../pages/ru/avideo/VideoRu-Open240816';
import VideoOpen240820En from '../pages/en/avideo/VideoEn-Open240820';
import VideoOpen240820Es from '../pages/es/avideo/VideoEs-Open240820';
import VideoOpen240820Ru from '../pages/ru/avideo/VideoRu-Open240820';
import VideoOpen240821En from '../pages/en/avideo/VideoEn-Open240821';
import VideoOpen240821Es from '../pages/es/avideo/VideoEs-Open240821';
import VideoOpen240821Ru from '../pages/ru/avideo/VideoRu-Open240821';
import VideoOpen240822En from '../pages/en/avideo/VideoEn-Open240822';
import VideoOpen240822Es from '../pages/es/avideo/VideoEs-Open240822';
import VideoOpen240822Ru from '../pages/ru/avideo/VideoRu-Open240822';
import VideoOpen240823En from '../pages/en/avideo/VideoEn-Open240823';
import VideoOpen240823Es from '../pages/es/avideo/VideoEs-Open240823';
import VideoOpen240823Ru from '../pages/ru/avideo/VideoRu-Open240823';
import VideoOpen240824En from '../pages/en/avideo/VideoEn-Open240824';
import VideoOpen240824Es from '../pages/es/avideo/VideoEs-Open240824';
import VideoOpen240824Ru from '../pages/ru/avideo/VideoRu-Open240824';
import VideoOpen240825En from '../pages/en/avideo/VideoEn-Open240825';
import VideoOpen240825Es from '../pages/es/avideo/VideoEs-Open240825';
import VideoOpen240825Ru from '../pages/ru/avideo/VideoRu-Open240825';
import VideoOpenShipEn from '../pages/en/avideo/VideoEn-Open240826';
import VideoOpenShipEs from '../pages/es/avideo/VideoEs-Open240826';
import VideoOpenShipRu from '../pages/ru/avideo/VideoRu-Open240826';
import VideoOpen240827En from '../pages/en/avideo/VideoEn-Open240827';
import VideoOpen240827Es from '../pages/es/avideo/VideoEs-Open240827';
import VideoOpen240827Ru from '../pages/ru/avideo/VideoRu-Open240827';
import VideoOpen240828En from '../pages/en/avideo/VideoEn-Open240828';
import VideoOpen240828Es from '../pages/es/avideo/VideoEs-Open240828';
import VideoOpen240828Ru from '../pages/ru/avideo/VideoRu-Open240828';
import VideoOpen240830En from '../pages/en/avideo/VideoEn-Open240830';
import VideoOpen240830Es from '../pages/es/avideo/VideoEs-Open240830';
import VideoOpen240830Ru from '../pages/ru/avideo/VideoRu-Open240830';
import VideoOpen240831En from '../pages/en/avideo/VideoEn-Open240831';
import VideoOpen240831Es from '../pages/es/avideo/VideoEs-Open240831';
import VideoOpen240831Ru from '../pages/ru/avideo/VideoRu-Open240831';
import VideoOpen240901En from '../pages/en/avideo/VideoEn-Open240901';
import VideoOpen240901Es from '../pages/es/avideo/VideoEs-Open240901';
import VideoOpen240901Ru from '../pages/ru/avideo/VideoRu-Open240901';
import VideoOpen240903En from '../pages/en/avideo/VideoEn-Open240903';
import VideoOpen240903Es from '../pages/es/avideo/VideoEs-Open240903';
import VideoOpen240903Ru from '../pages/ru/avideo/VideoRu-Open240903';
import VideoOpen240904En from '../pages/en/avideo/VideoEn-Open240904';
import VideoOpen240904Es from '../pages/es/avideo/VideoEs-Open240904';
import VideoOpen240904Ru from '../pages/ru/avideo/VideoRu-Open240904';
import VideoOpen240905En from '../pages/en/avideo/VideoEn-Open240905';
import VideoOpen240905Es from '../pages/es/avideo/VideoEs-Open240905';
import VideoOpen240905Ru from '../pages/ru/avideo/VideoRu-Open240905';
import VideoOpen240906En from '../pages/en/avideo/VideoEn-Open240906';
import VideoOpen240906Es from '../pages/es/avideo/VideoEs-Open240906';
import VideoOpen240906Ru from '../pages/ru/avideo/VideoRu-Open240906';
import VideoOpen240907En from '../pages/en/avideo/VideoEn-Open240907';
import VideoOpen240907Es from '../pages/es/avideo/VideoEs-Open240907';
import VideoOpen240907Ru from '../pages/ru/avideo/VideoRu-Open240907';
import VideoOpen240908En from '../pages/en/avideo/VideoEn-Open240908';
import VideoOpen240908Es from '../pages/es/avideo/VideoEs-Open240908';
import VideoOpen240908Ru from '../pages/ru/avideo/VideoRu-Open240908';
import VideoOpen240910En from '../pages/en/avideo/VideoEn-Open240910';
import VideoOpen240910Es from '../pages/es/avideo/VideoEs-Open240910';
import VideoOpen240910Ru from '../pages/ru/avideo/VideoRu-Open240910';
import VideoOpen240911En from '../pages/en/avideo/VideoEn-Open240911';
import VideoOpen240911Es from '../pages/es/avideo/VideoEs-Open240911';
import VideoOpen240911Ru from '../pages/ru/avideo/VideoRu-Open240911';
import VideoOpen240912En from '../pages/en/avideo/VideoEn-Open240912';
import VideoOpen240912Es from '../pages/es/avideo/VideoEs-Open240912';
import VideoOpen240912Ru from '../pages/ru/avideo/VideoRu-Open240912';
import VideoOpen240913En from '../pages/en/avideo/VideoEn-Open240913';
import VideoOpen240913Es from '../pages/es/avideo/VideoEs-Open240913';
import VideoOpen240913Ru from '../pages/ru/avideo/VideoRu-Open240913';
import VideoOpen240914En from '../pages/en/avideo/VideoEn-Open240914';
import VideoOpen240914Es from '../pages/es/avideo/VideoEs-Open240914';
import VideoOpen240914Ru from '../pages/ru/avideo/VideoRu-Open240914';
import VideoOpen240915En from '../pages/en/avideo/VideoEn-Open240915';
import VideoOpen240915Es from '../pages/es/avideo/VideoEs-Open240915';
import VideoOpen240915Ru from '../pages/ru/avideo/VideoRu-Open240915';
import VideoOpen240916En from '../pages/en/avideo/VideoEn-Open240916';
import VideoOpen240916Es from '../pages/es/avideo/VideoEs-Open240916';
import VideoOpen240916Ru from '../pages/ru/avideo/VideoRu-Open240916';
import VideoOpen240917En from '../pages/en/avideo/VideoEn-Open240917';
import VideoOpen240917Es from '../pages/es/avideo/VideoEs-Open240917';
import VideoOpen240917Ru from '../pages/ru/avideo/VideoRu-Open240917';
import VideoOpen240918En from '../pages/en/avideo/VideoEn-Open240918';
import VideoOpen240918Es from '../pages/es/avideo/VideoEs-Open240918';
import VideoOpen240918Ru from '../pages/ru/avideo/VideoRu-Open240918';
import VideoOpen240919En from '../pages/en/avideo/VideoEn-Open240919';
import VideoOpen240919Es from '../pages/es/avideo/VideoEs-Open240919';
import VideoOpen240919Ru from '../pages/ru/avideo/VideoRu-Open240919';
import VideoOpen240921En from '../pages/en/avideo/VideoEn-Open240921';
import VideoOpen240921Es from '../pages/es/avideo/VideoEs-Open240921';
import VideoOpen240921Ru from '../pages/ru/avideo/VideoRu-Open240921';
import VideoOpen240925En from '../pages/en/avideo/VideoEn-Open240925';
import VideoOpen240925Es from '../pages/es/avideo/VideoEs-Open240925';
import VideoOpen240925Ru from '../pages/ru/avideo/VideoRu-Open240925';
import VideoOpen240926En from '../pages/en/avideo/VideoEn-Open240926';
import VideoOpen240926Es from '../pages/es/avideo/VideoEs-Open240926';
import VideoOpen240926Ru from '../pages/ru/avideo/VideoRu-Open240926';
import VideoBrillo241009En from '../pages/en/avideo/VideoEn-Brillo241009';
import VideoBrillo241009Es from '../pages/es/avideo/VideoEs-Brillo241009';
import VideoBrillo241009Ru from '../pages/ru/avideo/VideoRu-Brillo241009';
import VideoBrillo241017En from '../pages/en/avideo/VideoEn-Brillo241017';
import VideoBrillo241017Es from '../pages/es/avideo/VideoEs-Brillo241017';
import VideoBrillo241017Ru from '../pages/ru/avideo/VideoRu-Brillo241017';
import VideoBrillo241031En from '../pages/en/avideo/VideoEn-Brillo241031';
import VideoBrillo241031Es from '../pages/es/avideo/VideoEs-Brillo241031';
import VideoBrillo241031Ru from '../pages/ru/avideo/VideoRu-Brillo241031';
import VideoBrillo241114En from '../pages/en/avideo/VideoEn-Brillo241114';
import VideoBrillo241114Es from '../pages/es/avideo/VideoEs-Brillo241114';
import VideoBrillo241114Ru from '../pages/ru/avideo/VideoRu-Brillo241114';
import VideoBrillo241121En from '../pages/en/avideo/VideoEn-Brillo241121';
import VideoBrillo241121Es from '../pages/es/avideo/VideoEs-Brillo241121';
import VideoBrillo241121Ru from '../pages/ru/avideo/VideoRu-Brillo241121';
import VideoBrillo241128En from '../pages/en/avideo/VideoEn-Brillo241128';
import VideoBrillo241128Es from '../pages/es/avideo/VideoEs-Brillo241128';
import VideoBrillo241128Ru from '../pages/ru/avideo/VideoRu-Brillo241128';
import VideoBrillo241205En from '../pages/en/avideo/VideoEn-Brillo241205';
import VideoBrillo241205Es from '../pages/es/avideo/VideoEs-Brillo241205';
import VideoBrillo241205Ru from '../pages/ru/avideo/VideoRu-Brillo241205';
import VideoBrillo241226En from '../pages/en/avideo/VideoEn-Brillo241226';
import VideoBrillo241226Es from '../pages/es/avideo/VideoEs-Brillo241226';
import VideoBrillo241226Ru from '../pages/ru/avideo/VideoRu-Brillo241226';
import VideoWDance250125En from '../pages/en/avideo/VideoEn-WDance250125';
import VideoWDance250125Es from '../pages/es/avideo/VideoEs-WDance250125';
import VideoWDance250125Ru from '../pages/ru/avideo/VideoRu-WDance250125';
import VideoOpen250418En from '../pages/en/avideo/VideoEn-Open250418';
import VideoOpen250418Es from '../pages/es/avideo/VideoEs-Open250418';
import VideoOpen250418Ru from '../pages/ru/avideo/VideoRu-Open250418';
import VideoOpen250419En from '../pages/en/avideo/VideoEn-Open250419';
import VideoOpen250419Es from '../pages/es/avideo/VideoEs-Open250419';
import VideoOpen250419Ru from '../pages/ru/avideo/VideoRu-Open250419';
import VideoOpen250522En from '../pages/en/avideo/VideoEn-Open250522';
import VideoOpen250522Es from '../pages/es/avideo/VideoEs-Open250522';
import VideoOpen250522Ru from '../pages/ru/avideo/VideoRu-Open250522';
import VideoOpen250523En from '../pages/en/avideo/VideoEn-Open250523';
import VideoOpen250523Es from '../pages/es/avideo/VideoEs-Open250523';
import VideoOpen250523Ru from '../pages/ru/avideo/VideoRu-Open250523';
import VideoOpen250524En from '../pages/en/avideo/VideoEn-Open250524';
import VideoOpen250524Es from '../pages/es/avideo/VideoEs-Open250524';
import VideoOpen250524Ru from '../pages/ru/avideo/VideoRu-Open250524'; 
import VideoTardeo250524En from '../pages/en/avideo/VideoEn-Tardeo250524';
import VideoTardeo250524Es from '../pages/es/avideo/VideoEs-Tardeo250524';
import VideoTardeo250524Ru from '../pages/ru/avideo/VideoRu-Tardeo250524';
import VideoOpen250525En from '../pages/en/avideo/VideoEn-Open250525';
import VideoOpen250525Es from '../pages/es/avideo/VideoEs-Open250525';
import VideoOpen250525Ru from '../pages/ru/avideo/VideoRu-Open250525';
import VideoOpen250528En from '../pages/en/avideo/VideoEn-Open250528';
import VideoOpen250528Es from '../pages/es/avideo/VideoEs-Open250528';
import VideoOpen250528Ru from '../pages/ru/avideo/VideoRu-Open250528';
import VideoOpen250529En from '../pages/en/avideo/VideoEn-Open250529';
import VideoOpen250529Es from '../pages/es/avideo/VideoEs-Open250529';
import VideoOpen250529Ru from '../pages/ru/avideo/VideoRu-Open250529';
import VideoOpen250530En from '../pages/en/avideo/VideoEn-Open250530';
import VideoOpen250530Es from '../pages/es/avideo/VideoEs-Open250530';
import VideoOpen250530Ru from '../pages/ru/avideo/VideoRu-Open250530';
import VideoOpen250531En from '../pages/en/avideo/VideoEn-Open250531';
import VideoOpen250531Es from '../pages/es/avideo/VideoEs-Open250531';
import VideoOpen250531Ru from '../pages/ru/avideo/VideoRu-Open250531';
import VideoOpen250601En from '../pages/en/avideo/VideoEn-Open250601';
import VideoOpen250601Es from '../pages/es/avideo/VideoEs-Open250601';
import VideoOpen250601Ru from '../pages/ru/avideo/VideoRu-Open250601';
import VideoOpen250604En from '../pages/en/avideo/VideoEn-Open250604';
import VideoOpen250604Es from '../pages/es/avideo/VideoEs-Open250604';
import VideoOpen250604Ru from '../pages/ru/avideo/VideoRu-Open250604';
import VideoOpen250605En from '../pages/en/avideo/VideoEn-Open250605';
import VideoOpen250605Es from '../pages/es/avideo/VideoEs-Open250605';
import VideoOpen250605Ru from '../pages/ru/avideo/VideoRu-Open250605';
import VideoOpen250606En from '../pages/en/avideo/VideoEn-Open250606';
import VideoOpen250606Es from '../pages/es/avideo/VideoEs-Open250606';
import VideoOpen250606Ru from '../pages/ru/avideo/VideoRu-Open250606';
import VideoOpen250607En from '../pages/en/avideo/VideoEn-Open250607';
import VideoOpen250607Es from '../pages/es/avideo/VideoEs-Open250607';
import VideoOpen250607Ru from '../pages/ru/avideo/VideoRu-Open250607';
import VideoOpen250611En from '../pages/en/avideo/VideoEn-Open250611';
import VideoOpen250611Es from '../pages/es/avideo/VideoEs-Open250611';
import VideoOpen250611Ru from '../pages/ru/avideo/VideoRu-Open250611';
import VideoOpen250612En from '../pages/en/avideo/VideoEn-Open250612';
import VideoOpen250612Es from '../pages/es/avideo/VideoEs-Open250612';
import VideoOpen250612Ru from '../pages/ru/avideo/VideoRu-Open250612';
import VideoOpen250616En from '../pages/en/avideo/VideoEn-Open250616';
import VideoOpen250616Es from '../pages/es/avideo/VideoEs-Open250616';
import VideoOpen250616Ru from '../pages/ru/avideo/VideoRu-Open250616';
import VideoOpen250623En from '../pages/en/avideo/VideoEn-Open250623';
import VideoOpen250623Es from '../pages/es/avideo/VideoEs-Open250623';
import VideoOpen250623Ru from '../pages/ru/avideo/VideoRu-Open250623';
import VideoOpen250625En from '../pages/en/avideo/VideoEn-Open250625';
import VideoOpen250625Es from '../pages/es/avideo/VideoEs-Open250625';
import VideoOpen250625Ru from '../pages/ru/avideo/VideoRu-Open250625';
import VideoOpen250628En from '../pages/en/avideo/VideoEn-Open250628';
import VideoOpen250628Es from '../pages/es/avideo/VideoEs-Open250628';
import VideoOpen250628Ru from '../pages/ru/avideo/VideoRu-Open250628';
import VideoOpen250702En from '../pages/en/avideo/VideoEn-Open250702';
import VideoOpen250702Es from '../pages/es/avideo/VideoEs-Open250702';
import VideoOpen250702Ru from '../pages/ru/avideo/VideoRu-Open250702';
import VideoOpen250703En from '../pages/en/avideo/VideoEn-Open250703';
import VideoOpen250703Es from '../pages/es/avideo/VideoEs-Open250703';
import VideoOpen250703Ru from '../pages/ru/avideo/VideoRu-Open250703';
import VideoOpen250704En from '../pages/en/avideo/VideoEn-Open250704';
import VideoOpen250704Es from '../pages/es/avideo/VideoEs-Open250704';
import VideoOpen250704Ru from '../pages/ru/avideo/VideoRu-Open250704';
import VideoOpen250705En from '../pages/en/avideo/VideoEn-Open250705';
import VideoOpen250705Es from '../pages/es/avideo/VideoEs-Open250705';
import VideoOpen250705Ru from '../pages/ru/avideo/VideoRu-Open250705';
import VideoOpen250706En from '../pages/en/avideo/VideoEn-Open250706';
import VideoOpen250706Es from '../pages/es/avideo/VideoEs-Open250706';
import VideoOpen250706Ru from '../pages/ru/avideo/VideoRu-Open250706';
import VideoOpen250707En from '../pages/en/avideo/VideoEn-Open250707';
import VideoOpen250707Es from '../pages/es/avideo/VideoEs-Open250707';
import VideoOpen250707Ru from '../pages/ru/avideo/VideoRu-Open250707';
import VideoOpen250709En from '../pages/en/avideo/VideoEn-Open250709';
import VideoOpen250709Es from '../pages/es/avideo/VideoEs-Open250709';
import VideoOpen250709Ru from '../pages/ru/avideo/VideoRu-Open250709';
import VideoOpen250710En from '../pages/en/avideo/VideoEn-Open250710';
import VideoOpen250710Es from '../pages/es/avideo/VideoEs-Open250710';
import VideoOpen250710Ru from '../pages/ru/avideo/VideoRu-Open250710';
import VideoOpen250711En from '../pages/en/avideo/VideoEn-Open250711';
import VideoOpen250711Es from '../pages/es/avideo/VideoEs-Open250711';
import VideoOpen250711Ru from '../pages/ru/avideo/VideoRu-Open250711';
import VideoOpen250712En from '../pages/en/avideo/VideoEn-Open250712';
import VideoOpen250712Es from '../pages/es/avideo/VideoEs-Open250712';
import VideoOpen250712Ru from '../pages/ru/avideo/VideoRu-Open250712';
import VideoOpen250713En from '../pages/en/avideo/VideoEn-Open250713';
import VideoOpen250713Es from '../pages/es/avideo/VideoEs-Open250713';
import VideoOpen250713Ru from '../pages/ru/avideo/VideoRu-Open250713';
import VideoOpen250714En from '../pages/en/avideo/VideoEn-Open250714';
import VideoOpen250714Es from '../pages/es/avideo/VideoEs-Open250714';
import VideoOpen250714Ru from '../pages/ru/avideo/VideoRu-Open250714';
import VideoOpen250716En from '../pages/en/avideo/VideoEn-Open250716';
import VideoOpen250716Es from '../pages/es/avideo/VideoEs-Open250716';
import VideoOpen250716Ru from '../pages/ru/avideo/VideoRu-Open250716';
import VideoOpen250717En from '../pages/en/avideo/VideoEn-Open250717';
import VideoOpen250717Es from '../pages/es/avideo/VideoEs-Open250717';
import VideoOpen250717Ru from '../pages/ru/avideo/VideoRu-Open250717';
import VideoOpen250718En from '../pages/en/avideo/VideoEn-Open250718';
import VideoOpen250718Es from '../pages/es/avideo/VideoEs-Open250718';
import VideoOpen250718Ru from '../pages/ru/avideo/VideoRu-Open250718';
import VideoOpen250720En from '../pages/en/avideo/VideoEn-Open250720';
import VideoOpen250720Es from '../pages/es/avideo/VideoEs-Open250720';
import VideoOpen250720Ru from '../pages/ru/avideo/VideoRu-Open250720';
import VideoOpen250721En from '../pages/en/avideo/VideoEn-Open250721';
import VideoOpen250721Es from '../pages/es/avideo/VideoEs-Open250721';
import VideoOpen250721Ru from '../pages/ru/avideo/VideoRu-Open250721';
import VideoOpen250722En from '../pages/en/avideo/VideoEn-Open250722';
import VideoOpen250722Es from '../pages/es/avideo/VideoEs-Open250722';
import VideoOpen250722Ru from '../pages/ru/avideo/VideoRu-Open250722';
import VideoOpen250723En from '../pages/en/avideo/VideoEn-Open250723';
import VideoOpen250723Es from '../pages/es/avideo/VideoEs-Open250723';
import VideoOpen250723Ru from '../pages/ru/avideo/VideoRu-Open250723';
import VideoOpen250725En from '../pages/en/avideo/VideoEn-Open250725';
import VideoOpen250725Es from '../pages/es/avideo/VideoEs-Open250725';
import VideoOpen250725Ru from '../pages/ru/avideo/VideoRu-Open250725';
import VideoOpen250726En from '../pages/en/avideo/VideoEn-Open250726';
import VideoOpen250726Es from '../pages/es/avideo/VideoEs-Open250726';
import VideoOpen250726Ru from '../pages/ru/avideo/VideoRu-Open250726';
import VideoOpen250727En from '../pages/en/avideo/VideoEn-Open250727';
import VideoOpen250727Es from '../pages/es/avideo/VideoEs-Open250727';
import VideoOpen250727Ru from '../pages/ru/avideo/VideoRu-Open250727';
import VideoOpen250728En from '../pages/en/avideo/VideoEn-Open250728';
import VideoOpen250728Es from '../pages/es/avideo/VideoEs-Open250728';
import VideoOpen250728Ru from '../pages/ru/avideo/VideoRu-Open250728';
import VideoOpen250729En from '../pages/en/avideo/VideoEn-Open250729';
import VideoOpen250729Es from '../pages/es/avideo/VideoEs-Open250729';
import VideoOpen250729Ru from '../pages/ru/avideo/VideoRu-Open250729';
import VideoOpen250730En from '../pages/en/avideo/VideoEn-Open250730';
import VideoOpen250730Es from '../pages/es/avideo/VideoEs-Open250730';
import VideoOpen250730Ru from '../pages/ru/avideo/VideoRu-Open250730';
import VideoOpen250731En from '../pages/en/avideo/VideoEn-Open250731';
import VideoOpen250731Es from '../pages/es/avideo/VideoEs-Open250731';
import VideoOpen250731Ru from '../pages/ru/avideo/VideoRu-Open250731';
import VideoOpen250801En from '../pages/en/avideo/VideoEn-Open250801';
import VideoOpen250801Es from '../pages/es/avideo/VideoEs-Open250801';
import VideoOpen250801Ru from '../pages/ru/avideo/VideoRu-Open250801';
import VideoOpen250802En from '../pages/en/avideo/VideoEn-Open250802';
import VideoOpen250802Es from '../pages/es/avideo/VideoEs-Open250802';
import VideoOpen250802Ru from '../pages/ru/avideo/VideoRu-Open250802';
import VideoOpen250803En from '../pages/en/avideo/VideoEn-Open250803';
import VideoOpen250803Es from '../pages/es/avideo/VideoEs-Open250803';
import VideoOpen250803Ru from '../pages/ru/avideo/VideoRu-Open250803';
import VideoOpen250805En from '../pages/en/avideo/VideoEn-Open250805';
import VideoOpen250805Es from '../pages/es/avideo/VideoEs-Open250805';
import VideoOpen250805Ru from '../pages/ru/avideo/VideoRu-Open250805';
import VideoOpen250806En from '../pages/en/avideo/VideoEn-Open250806';
import VideoOpen250806Es from '../pages/es/avideo/VideoEs-Open250806';
import VideoOpen250806Ru from '../pages/ru/avideo/VideoRu-Open250806';
import VideoOpen250807En from '../pages/en/avideo/VideoEn-Open250807';
import VideoOpen250807Es from '../pages/es/avideo/VideoEs-Open250807';
import VideoOpen250807Ru from '../pages/ru/avideo/VideoRu-Open250807';
import VideoOpen250809En from '../pages/en/avideo/VideoEn-Open250809';
import VideoOpen250809Es from '../pages/es/avideo/VideoEs-Open250809';
import VideoOpen250809Ru from '../pages/ru/avideo/VideoRu-Open250809';
import VideoOpen250810En from '../pages/en/avideo/VideoEn-Open250810';
import VideoOpen250810Es from '../pages/es/avideo/VideoEs-Open250810';
import VideoOpen250810Ru from '../pages/ru/avideo/VideoRu-Open250810';
import VideoOpen250813En from '../pages/en/avideo/VideoEn-Open250813';
import VideoOpen250813Es from '../pages/es/avideo/VideoEs-Open250813';
import VideoOpen250813Ru from '../pages/ru/avideo/VideoRu-Open250813';
import VideoOpen250814En from '../pages/en/avideo/VideoEn-Open250814';
import VideoOpen250814Es from '../pages/es/avideo/VideoEs-Open250814';
import VideoOpen250814Ru from '../pages/ru/avideo/VideoRu-Open250814';
import VideoOpen250816En from '../pages/en/avideo/VideoEn-Open250816';
import VideoOpen250816Es from '../pages/es/avideo/VideoEs-Open250816';
import VideoOpen250816Ru from '../pages/ru/avideo/VideoRu-Open250816';
import VideoOpen250817En from '../pages/en/avideo/VideoEn-Open250817';
import VideoOpen250817Es from '../pages/es/avideo/VideoEs-Open250817';
import VideoOpen250817Ru from '../pages/ru/avideo/VideoRu-Open250817';
import VideoOpen250821En from '../pages/en/avideo/VideoEn-Open250821';
import VideoOpen250821Es from '../pages/es/avideo/VideoEs-Open250821';
import VideoOpen250821Ru from '../pages/ru/avideo/VideoRu-Open250821';
import VideoOpen250823En from '../pages/en/avideo/VideoEn-Open250823';
import VideoOpen250823Es from '../pages/es/avideo/VideoEs-Open250823';
import VideoOpen250823Ru from '../pages/ru/avideo/VideoRu-Open250823';
import VideoOpen250824En from '../pages/en/avideo/VideoEn-Open250824';
import VideoOpen250824Es from '../pages/es/avideo/VideoEs-Open250824';
import VideoOpen250824Ru from '../pages/ru/avideo/VideoRu-Open250824';
import VideoOpen250825En from '../pages/en/avideo/VideoEn-Open250825';
import VideoOpen250825Es from '../pages/es/avideo/VideoEs-Open250825';
import VideoOpen250825Ru from '../pages/ru/avideo/VideoRu-Open250825';
import VideoOpen250827En from '../pages/en/avideo/VideoEn-Open250827';
import VideoOpen250827Es from '../pages/es/avideo/VideoEs-Open250827';
import VideoOpen250827Ru from '../pages/ru/avideo/VideoRu-Open250827';
import VideoOpen250828En from '../pages/en/avideo/VideoEn-Open250828';
import VideoOpen250828Es from '../pages/es/avideo/VideoEs-Open250828';
import VideoOpen250828Ru from '../pages/ru/avideo/VideoRu-Open250828';
import VideoOpen250830En from '../pages/en/avideo/VideoEn-Open250830';
import VideoOpen250830Es from '../pages/es/avideo/VideoEs-Open250830';
import VideoOpen250830Ru from '../pages/ru/avideo/VideoRu-Open250830';
import VideoOpen250831En from '../pages/en/avideo/VideoEn-Open250831';
import VideoOpen250831Es from '../pages/es/avideo/VideoEs-Open250831';
import VideoOpen250831Ru from '../pages/ru/avideo/VideoRu-Open250831';
import VideoOpen250901En from '../pages/en/avideo/VideoEn-Open250901';
import VideoOpen250901Es from '../pages/es/avideo/VideoEs-Open250901';
import VideoOpen250901Ru from '../pages/ru/avideo/VideoRu-Open250901';
import VideoOpen250903En from '../pages/en/avideo/VideoEn-Open250903';
import VideoOpen250903Es from '../pages/es/avideo/VideoEs-Open250903';
import VideoOpen250903Ru from '../pages/ru/avideo/VideoRu-Open250903';
import VideoOpen250904En from '../pages/en/avideo/VideoEn-Open250904';
import VideoOpen250904Es from '../pages/es/avideo/VideoEs-Open250904';
import VideoOpen250904Ru from '../pages/ru/avideo/VideoRu-Open250904';
import VideoOpen250906En from '../pages/en/avideo/VideoEn-Open250906';
import VideoOpen250906Es from '../pages/es/avideo/VideoEs-Open250906';
import VideoOpen250906Ru from '../pages/ru/avideo/VideoRu-Open250906';
import VideoOpen250907En from '../pages/en/avideo/VideoEn-Open250907';
import VideoOpen250907Es from '../pages/es/avideo/VideoEs-Open250907';
import VideoOpen250907Ru from '../pages/ru/avideo/VideoRu-Open250907';
import VideoOpen250908En from '../pages/en/avideo/VideoEn-Open250908';
import VideoOpen250908Es from '../pages/es/avideo/VideoEs-Open250908';
import VideoOpen250908Ru from '../pages/ru/avideo/VideoRu-Open250908';
import VideoOpen250910En from '../pages/en/avideo/VideoEn-Open250910';
import VideoOpen250910Es from '../pages/es/avideo/VideoEs-Open250910';
import VideoOpen250910Ru from '../pages/ru/avideo/VideoRu-Open250910';
import VideoOpen250911En from '../pages/en/avideo/VideoEn-Open250911';
import VideoOpen250911Es from '../pages/es/avideo/VideoEs-Open250911';
import VideoOpen250911Ru from '../pages/ru/avideo/VideoRu-Open250911';
import VideoOpen250913En from '../pages/en/avideo/VideoEn-Open250913';
import VideoOpen250913Es from '../pages/es/avideo/VideoEs-Open250913';
import VideoOpen250913Ru from '../pages/ru/avideo/VideoRu-Open250913';
import VideoOpen250914En from '../pages/en/avideo/VideoEn-Open250914';
import VideoOpen250914Es from '../pages/es/avideo/VideoEs-Open250914';
import VideoOpen250914Ru from '../pages/ru/avideo/VideoRu-Open250914';
import VideoOpen250915En from '../pages/en/avideo/VideoEn-Open250915';
import VideoOpen250915Es from '../pages/es/avideo/VideoEs-Open250915';
import VideoOpen250915Ru from '../pages/ru/avideo/VideoRu-Open250915';
import VideoOpen250917En from '../pages/en/avideo/VideoEn-Open250917';
import VideoOpen250917Es from '../pages/es/avideo/VideoEs-Open250917';
import VideoOpen250917Ru from '../pages/ru/avideo/VideoRu-Open250917';
import VideoOpen250920En from '../pages/en/avideo/VideoEn-Open250920';
import VideoOpen250920Es from '../pages/es/avideo/VideoEs-Open250920';
import VideoOpen250920Ru from '../pages/ru/avideo/VideoRu-Open250920';
import VideoOpen250921En from '../pages/en/avideo/VideoEn-Open250921';
import VideoOpen250921Es from '../pages/es/avideo/VideoEs-Open250921';
import VideoOpen250921Ru from '../pages/ru/avideo/VideoRu-Open250921';
import VideoOpen250922En from '../pages/en/avideo/VideoEn-Open250922';
import VideoOpen250922Es from '../pages/es/avideo/VideoEs-Open250922';
import VideoOpen250922Ru from '../pages/ru/avideo/VideoRu-Open250922';
import VideoOpen250928En from '../pages/en/avideo/VideoEn-Open250928';
import VideoOpen250928Es from '../pages/es/avideo/VideoEs-Open250928';
import VideoOpen250928Ru from '../pages/ru/avideo/VideoRu-Open250928';
import VideoOpen251005En from '../pages/en/avideo/VideoEn-Open251005';
import VideoOpen251005Es from '../pages/es/avideo/VideoEs-Open251005';
import VideoOpen251005Ru from '../pages/ru/avideo/VideoRu-Open251005';
import VideoOpen251012En from '../pages/en/avideo/VideoEn-Open251012';
import VideoOpen251012Es from '../pages/es/avideo/VideoEs-Open251012';
import VideoOpen251012Ru from '../pages/ru/avideo/VideoRu-Open251012';
import VideoOpen251019En from '../pages/en/avideo/VideoEn-Open251019';
import VideoOpen251019Es from '../pages/es/avideo/VideoEs-Open251019';
import VideoOpen251019Ru from '../pages/ru/avideo/VideoRu-Open251019';
import VideoOpen251026En from '../pages/en/avideo/VideoEn-Open251026';
import VideoOpen251026Es from '../pages/es/avideo/VideoEs-Open251026';
import VideoOpen251026Ru from '../pages/ru/avideo/VideoRu-Open251026';
import VideoOpen251102En from '../pages/en/avideo/VideoEn-Open251102';
import VideoOpen251102Es from '../pages/es/avideo/VideoEs-Open251102';
import VideoOpen251102Ru from '../pages/ru/avideo/VideoRu-Open251102';
import VideoOpen251109En from '../pages/en/avideo/VideoEn-Open251109';
import VideoOpen251109Es from '../pages/es/avideo/VideoEs-Open251109';
import VideoOpen251109Ru from '../pages/ru/avideo/VideoRu-Open251109';
import VideoOpen251116En from '../pages/en/avideo/VideoEn-Open251116';
import VideoOpen251116Es from '../pages/es/avideo/VideoEs-Open251116';
import VideoOpen251116Ru from '../pages/ru/avideo/VideoRu-Open251116';
import VideoOpen251123En from '../pages/en/avideo/VideoEn-Open251123';
import VideoOpen251123Es from '../pages/es/avideo/VideoEs-Open251123';
import VideoOpen251123Ru from '../pages/ru/avideo/VideoRu-Open251123';
import VideoOpen251130En from '../pages/en/avideo/VideoEn-Open251130';
import VideoOpen251130Es from '../pages/es/avideo/VideoEs-Open251130';
import VideoOpen251130Ru from '../pages/ru/avideo/VideoRu-Open251130';
import VideoOpen251214En from '../pages/en/avideo/VideoEn-Open251214';
import VideoOpen251214Es from '../pages/es/avideo/VideoEs-Open251214';
import VideoOpen251214Ru from '../pages/ru/avideo/VideoRu-Open251214';
import VideoOpen251221En from '../pages/en/avideo/VideoEn-Open251221';
import VideoOpen251221Es from '../pages/es/avideo/VideoEs-Open251221';
import VideoOpen251221Ru from '../pages/ru/avideo/VideoRu-Open251221';
import VideoOpen251228En from '../pages/en/avideo/VideoEn-Open251228';
import VideoOpen251228Es from '../pages/es/avideo/VideoEs-Open251228';
import VideoOpen251228Ru from '../pages/ru/avideo/VideoRu-Open251228';
import VideoOpen260104En from '../pages/en/avideo/VideoEn-Open260104';
import VideoOpen260104Es from '../pages/es/avideo/VideoEs-Open260104';
import VideoOpen260104Ru from '../pages/ru/avideo/VideoRu-Open260104';
import VideoOpen260111En from '../pages/en/avideo/VideoEn-Open260111';
import VideoOpen260111Es from '../pages/es/avideo/VideoEs-Open260111';
import VideoOpen260111Ru from '../pages/ru/avideo/VideoRu-Open260111';
import VideoOpen260118En from '../pages/en/avideo/VideoEn-Open260118';
import VideoOpen260118Es from '../pages/es/avideo/VideoEs-Open260118';
import VideoOpen260118Ru from '../pages/ru/avideo/VideoRu-Open260118';
import VideoOpen260125En from '../pages/en/avideo/VideoEn-Open260125';
import VideoOpen260125Es from '../pages/es/avideo/VideoEs-Open260125';
import VideoOpen260125Ru from '../pages/ru/avideo/VideoRu-Open260125';
import VideoOpen260201En from '../pages/en/avideo/VideoEn-Open260201';
import VideoOpen260201Es from '../pages/es/avideo/VideoEs-Open260201';
import VideoOpen260201Ru from '../pages/ru/avideo/VideoRu-Open260201';
import VideoOpen260215En from '../pages/en/avideo/VideoEn-Open260215';
import VideoOpen260215Es from '../pages/es/avideo/VideoEs-Open260215';
import VideoOpen260215Ru from '../pages/ru/avideo/VideoRu-Open260215';
import VideoOpen260222En from '../pages/en/avideo/VideoEn-Open260222';
import VideoOpen260222Es from '../pages/es/avideo/VideoEs-Open260222';
import VideoOpen260222Ru from '../pages/ru/avideo/VideoRu-Open260222';
import VideoOpen260301En from '../pages/en/avideo/VideoEn-Open260301';
import VideoOpen260301Es from '../pages/es/avideo/VideoEs-Open260301';
import VideoOpen260301Ru from '../pages/ru/avideo/VideoRu-Open260301';
import VideoOpen260308En from '../pages/en/avideo/VideoEn-Open260308';
import VideoOpen260308Es from '../pages/es/avideo/VideoEs-Open260308';
import VideoOpen260308Ru from '../pages/ru/avideo/VideoRu-Open260308';
import VideoOpen260315En from '../pages/en/avideo/VideoEn-Open260315';
import VideoOpen260315Es from '../pages/es/avideo/VideoEs-Open260315';
import VideoOpen260315Ru from '../pages/ru/avideo/VideoRu-Open260315';
import VideoOpen260322En from '../pages/en/avideo/VideoEn-Open260322';
import VideoOpen260322Es from '../pages/es/avideo/VideoEs-Open260322';
import VideoOpen260322Ru from '../pages/ru/avideo/VideoRu-Open260322';
import VideoOpen260329En from '../pages/en/avideo/VideoEn-Open260329';
import VideoOpen260329Es from '../pages/es/avideo/VideoEs-Open260329';
import VideoOpen260329Ru from '../pages/ru/avideo/VideoRu-Open260329';
import VideoOpen260405En from '../pages/en/avideo/VideoEn-Open260405';
import VideoOpen260405Es from '../pages/es/avideo/VideoEs-Open260405';
import VideoOpen260405Ru from '../pages/ru/avideo/VideoRu-Open260405';
import VideoOpen260412En from '../pages/en/avideo/VideoEn-Open260412';
import VideoOpen260412Es from '../pages/es/avideo/VideoEs-Open260412';
import VideoOpen260412Ru from '../pages/ru/avideo/VideoRu-Open260412';
import VideoOpen260419En from '../pages/en/avideo/VideoEn-Open260419';
import VideoOpen260419Es from '../pages/es/avideo/VideoEs-Open260419';
import VideoOpen260419Ru from '../pages/ru/avideo/VideoRu-Open260419';
import VideoOpen260426En from '../pages/en/avideo/VideoEn-Open260426';
import VideoOpen260426Es from '../pages/es/avideo/VideoEs-Open260426';
import VideoOpen260426Ru from '../pages/ru/avideo/VideoRu-Open260426';
import VideoOpen260503En from '../pages/en/avideo/VideoEn-Open260503';
import VideoOpen260503Es from '../pages/es/avideo/VideoEs-Open260503';
import VideoOpen260503Ru from '../pages/ru/avideo/VideoRu-Open260503';
import VideoOpen260506En from '../pages/en/avideo/VideoEn-Open260506';
import VideoOpen260506Es from '../pages/es/avideo/VideoEs-Open260506';
import VideoOpen260506Ru from '../pages/ru/avideo/VideoRu-Open260506';
import VideoOpen260509En from '../pages/en/avideo/VideoEn-Open260509';
import VideoOpen260509Es from '../pages/es/avideo/VideoEs-Open260509';
import VideoOpen260509Ru from '../pages/ru/avideo/VideoRu-Open260509';
import VideoOpen260510En from '../pages/en/avideo/VideoEn-Open260510';
import VideoOpen260510Es from '../pages/es/avideo/VideoEs-Open260510';
import VideoOpen260510Ru from '../pages/ru/avideo/VideoRu-Open260510';
import VideoOpen260512En from '../pages/en/avideo/VideoEn-Open260512';
import VideoOpen260512Es from '../pages/es/avideo/VideoEs-Open260512';
import VideoOpen260512Ru from '../pages/ru/avideo/VideoRu-Open260512';
import VideoOpen260513En from '../pages/en/avideo/VideoEn-Open260513';
import VideoOpen260513Es from '../pages/es/avideo/VideoEs-Open260513';
import VideoOpen260513Ru from '../pages/ru/avideo/VideoRu-Open260513';
import VideoOpen260514En from '../pages/en/avideo/VideoEn-Open260514';
import VideoOpen260514Es from '../pages/es/avideo/VideoEs-Open260514';
import VideoOpen260514Ru from '../pages/ru/avideo/VideoRu-Open260514';
import VideoOpen260516En from '../pages/en/avideo/VideoEn-Open260516';
import VideoOpen260516Es from '../pages/es/avideo/VideoEs-Open260516';
import VideoOpen260516Ru from '../pages/ru/avideo/VideoRu-Open260516';
import VideoOpen260517En from '../pages/en/avideo/VideoEn-Open260517';
import VideoOpen260517Es from '../pages/es/avideo/VideoEs-Open260517';
import VideoOpen260517Ru from '../pages/ru/avideo/VideoRu-Open260517';
import VideoOpen260518En from '../pages/en/avideo/VideoEn-Open260518';
import VideoOpen260518Es from '../pages/es/avideo/VideoEs-Open260518';
import VideoOpen260518Ru from '../pages/ru/avideo/VideoRu-Open260518';
import VideoOpen260519En from '../pages/en/avideo/VideoEn-Open260519';
import VideoOpen260519Es from '../pages/es/avideo/VideoEs-Open260519';
import VideoOpen260519Ru from '../pages/ru/avideo/VideoRu-Open260519';
import VideoOpen260520En from '../pages/en/avideo/VideoEn-Open260520';
import VideoOpen260520Es from '../pages/es/avideo/VideoEs-Open260520';
import VideoOpen260520Ru from '../pages/ru/avideo/VideoRu-Open260520';
import VideoOpen260521En from '../pages/en/avideo/VideoEn-Open260521';
import VideoOpen260521Es from '../pages/es/avideo/VideoEs-Open260521';
import VideoOpen260521Ru from '../pages/ru/avideo/VideoRu-Open260521';
import VideoOpen260522En from '../pages/en/avideo/VideoEn-Open260522';
import VideoOpen260522Es from '../pages/es/avideo/VideoEs-Open260522';
import VideoOpen260522Ru from '../pages/ru/avideo/VideoRu-Open260522';
import VideoOpen260523En from '../pages/en/avideo/VideoEn-Open260523';
import VideoOpen260523Es from '../pages/es/avideo/VideoEs-Open260523';
import VideoOpen260523Ru from '../pages/ru/avideo/VideoRu-Open260523';
import VideoOpen260524En from '../pages/en/avideo/VideoEn-Open260524';
import VideoOpen260524Es from '../pages/es/avideo/VideoEs-Open260524';
import VideoOpen260524Ru from '../pages/ru/avideo/VideoRu-Open260524';
import VideoOpen260530En from '../pages/en/avideo/VideoEn-Open260530';
import VideoOpen260530Es from '../pages/es/avideo/VideoEs-Open260530';
import VideoOpen260530Ru from '../pages/ru/avideo/VideoRu-Open260530';
import VideoOpen260531En from '../pages/en/avideo/VideoEn-Open260531';
import VideoOpen260531Es from '../pages/es/avideo/VideoEs-Open260531';
import VideoOpen260531Ru from '../pages/ru/avideo/VideoRu-Open260531';
import VideoOpen260601En from '../pages/en/avideo/VideoEn-Open260601';
import VideoOpen260601Es from '../pages/es/avideo/VideoEs-Open260601';
import VideoOpen260601Ru from '../pages/ru/avideo/VideoRu-Open260601';
import VideoOpen260602En from '../pages/en/avideo/VideoEn-Open260602';
import VideoOpen260602Es from '../pages/es/avideo/VideoEs-Open260602';
import VideoOpen260602Ru from '../pages/ru/avideo/VideoRu-Open260602';
import VideoOpen260603En from '../pages/en/avideo/VideoEn-Open260603';
import VideoOpen260603Es from '../pages/es/avideo/VideoEs-Open260603';
import VideoOpen260603Ru from '../pages/ru/avideo/VideoRu-Open260603';
import VideoOpen260604En from '../pages/en/avideo/VideoEn-Open260604';
import VideoOpen260604Es from '../pages/es/avideo/VideoEs-Open260604';
import VideoOpen260604Ru from '../pages/ru/avideo/VideoRu-Open260604';
import VideoOpen260605En from '../pages/en/avideo/VideoEn-Open260605';
import VideoOpen260605Es from '../pages/es/avideo/VideoEs-Open260605';
import VideoOpen260605Ru from '../pages/ru/avideo/VideoRu-Open260605';
import VideoOpen260606En from '../pages/en/avideo/VideoEn-Open260606';
import VideoOpen260606Es from '../pages/es/avideo/VideoEs-Open260606';
import VideoOpen260606Ru from '../pages/ru/avideo/VideoRu-Open260606';
import VideoOpen260607En from '../pages/en/avideo/VideoEn-Open260607';
import VideoOpen260607Es from '../pages/es/avideo/VideoEs-Open260607';
import VideoOpen260607Ru from '../pages/ru/avideo/VideoRu-Open260607';
import VideoOpen260608En from '../pages/en/avideo/VideoEn-Open260608';
import VideoOpen260608Es from '../pages/es/avideo/VideoEs-Open260608';
import VideoOpen260608Ru from '../pages/ru/avideo/VideoRu-Open260608';
import VideoOpen260609En from '../pages/en/avideo/VideoEn-Open260609';
import VideoOpen260609Es from '../pages/es/avideo/VideoEs-Open260609';
import VideoOpen260609Ru from '../pages/ru/avideo/VideoRu-Open260609';
import VideoOpen260610En from '../pages/en/avideo/VideoEn-Open260610';
import VideoOpen260610Es from '../pages/es/avideo/VideoEs-Open260610';
import VideoOpen260610Ru from '../pages/ru/avideo/VideoRu-Open260610';
import VideoOpen260611En from '../pages/en/avideo/VideoEn-Open260611';
import VideoOpen260611Es from '../pages/es/avideo/VideoEs-Open260611';
import VideoOpen260611Ru from '../pages/ru/avideo/VideoRu-Open260611';
import VideoOpen260612En from '../pages/en/avideo/VideoEn-Open260612';
import VideoOpen260612Es from '../pages/es/avideo/VideoEs-Open260612';
import VideoOpen260612Ru from '../pages/ru/avideo/VideoRu-Open260612';
import VideoOpen260614En from '../pages/en/avideo/VideoEn-Open260614';
import VideoOpen260614Es from '../pages/es/avideo/VideoEs-Open260614';
import VideoOpen260614Ru from '../pages/ru/avideo/VideoRu-Open260614';
import VideoOpen260617En from '../pages/en/avideo/VideoEn-Open260617';
import VideoOpen260617Es from '../pages/es/avideo/VideoEs-Open260617';
import VideoOpen260617Ru from '../pages/ru/avideo/VideoRu-Open260617';
import VideoOpen260620En from '../pages/en/avideo/VideoEn-Open260620';
import VideoOpen260620Es from '../pages/es/avideo/VideoEs-Open260620';
import VideoOpen260620Ru from '../pages/ru/avideo/VideoRu-Open260620';    
import VideoOpen260621En from '../pages/en/avideo/VideoEn-Open260621';
import VideoOpen260621Es from '../pages/es/avideo/VideoEs-Open260621';
import VideoOpen260621Ru from '../pages/ru/avideo/VideoRu-Open260621'; 
import VideoOpen260622En from '../pages/en/avideo/VideoEn-Open260622';
import VideoOpen260622Es from '../pages/es/avideo/VideoEs-Open260622';
import VideoOpen260622Ru from '../pages/ru/avideo/VideoRu-Open260622';
import VideoOpen260623En from '../pages/en/avideo/VideoEn-Open260623';
import VideoOpen260623Es from '../pages/es/avideo/VideoEs-Open260623';
import VideoOpen260623Ru from '../pages/ru/avideo/VideoRu-Open260623';
import VideoOpen260624En from '../pages/en/avideo/VideoEn-Open260624';
import VideoOpen260624Es from '../pages/es/avideo/VideoEs-Open260624';
import VideoOpen260624Ru from '../pages/ru/avideo/VideoRu-Open260624';
import VideoOpen260625En from '../pages/en/avideo/VideoEn-Open260625';
import VideoOpen260625Es from '../pages/es/avideo/VideoEs-Open260625';
import VideoOpen260625Ru from '../pages/ru/avideo/VideoRu-Open260625';
import VideoOpen260626En from '../pages/en/avideo/VideoEn-Open260626';
import VideoOpen260626Es from '../pages/es/avideo/VideoEs-Open260626';
import VideoOpen260626Ru from '../pages/ru/avideo/VideoRu-Open260626';
import VideoOpen260627En from '../pages/en/avideo/VideoEn-Open260627';
import VideoOpen260627Es from '../pages/es/avideo/VideoEs-Open260627';
import VideoOpen260627Ru from '../pages/ru/avideo/VideoRu-Open260627';
import VideoOpen260628En from '../pages/en/avideo/VideoEn-Open260628';
import VideoOpen260628Es from '../pages/es/avideo/VideoEs-Open260628';
import VideoOpen260628Ru from '../pages/ru/avideo/VideoRu-Open260628';
import VideoOpen260629En from '../pages/en/avideo/VideoEn-Open260629';
import VideoOpen260629Es from '../pages/es/avideo/VideoEs-Open260629';
import VideoOpen260629Ru from '../pages/ru/avideo/VideoRu-Open260629';
import VideoOpen260701En from '../pages/en/avideo/VideoEn-Open260701';
import VideoOpen260701Es from '../pages/es/avideo/VideoEs-Open260701';
import VideoOpen260701Ru from '../pages/ru/avideo/VideoRu-Open260701';
import VideoOpen260702En from '../pages/en/avideo/VideoEn-Open260702';
import VideoOpen260702Es from '../pages/es/avideo/VideoEs-Open260702';
import VideoOpen260702Ru from '../pages/ru/avideo/VideoRu-Open260702';
import VideoOpen260703En from '../pages/en/avideo/VideoEn-Open260703';
import VideoOpen260703Es from '../pages/es/avideo/VideoEs-Open260703';
import VideoOpen260703Ru from '../pages/ru/avideo/VideoRu-Open260703';
import VideoOpen260704En from '../pages/en/avideo/VideoEn-Open260704';
import VideoOpen260704Es from '../pages/es/avideo/VideoEs-Open260704';
import VideoOpen260704Ru from '../pages/ru/avideo/VideoRu-Open260704';
import VideoOpen260705En from '../pages/en/avideo/VideoEn-Open260705';
import VideoOpen260705Es from '../pages/es/avideo/VideoEs-Open260705';
import VideoOpen260705Ru from '../pages/ru/avideo/VideoRu-Open260705';
import VideoOpen260706En from '../pages/en/avideo/VideoEn-Open260706';
import VideoOpen260706Es from '../pages/es/avideo/VideoEs-Open260706';
import VideoOpen260706Ru from '../pages/ru/avideo/VideoRu-Open260706';
import VideoOpen260708En from '../pages/en/avideo/VideoEn-Open260708';
import VideoOpen260708Es from '../pages/es/avideo/VideoEs-Open260708';
import VideoOpen260708Ru from '../pages/ru/avideo/VideoRu-Open260708';
import VideoOpen260709En from '../pages/en/avideo/VideoEn-Open260709';
import VideoOpen260709Es from '../pages/es/avideo/VideoEs-Open260709';
import VideoOpen260709Ru from '../pages/ru/avideo/VideoRu-Open260709';
import VideoOpen260710En from '../pages/en/avideo/VideoEn-Open260710';
import VideoOpen260710Es from '../pages/es/avideo/VideoEs-Open260710';
import VideoOpen260710Ru from '../pages/ru/avideo/VideoRu-Open260710';
import VideoOpen260711En from '../pages/en/avideo/VideoEn-Open260711';
import VideoOpen260711Es from '../pages/es/avideo/VideoEs-Open260711';
import VideoOpen260711Ru from '../pages/ru/avideo/VideoRu-Open260711';
import VideoOpen260713En from '../pages/en/avideo/VideoEn-Open260713';
import VideoOpen260713Es from '../pages/es/avideo/VideoEs-Open260713';
import VideoOpen260713Ru from '../pages/ru/avideo/VideoRu-Open260713';
import VideoOpen260714En from '../pages/en/avideo/VideoEn-Open260714';
import VideoOpen260714Es from '../pages/es/avideo/VideoEs-Open260714';
import VideoOpen260714Ru from '../pages/ru/avideo/VideoRu-Open260714';
import VideoOpen260715En from '../pages/en/avideo/VideoEn-Open260715';
import VideoOpen260715Es from '../pages/es/avideo/VideoEs-Open260715';
import VideoOpen260715Ru from '../pages/ru/avideo/VideoRu-Open260715';
import VideoOpen260716En from '../pages/en/avideo/VideoEn-Open260716';
import VideoOpen260716Es from '../pages/es/avideo/VideoEs-Open260716';
import VideoOpen260716Ru from '../pages/ru/avideo/VideoRu-Open260716';
import VideoOpen260717En from '../pages/en/avideo/VideoEn-Open260717';
import VideoOpen260717Es from '../pages/es/avideo/VideoEs-Open260717';
import VideoOpen260717Ru from '../pages/ru/avideo/VideoRu-Open260717';
import VideoOpen260718En from '../pages/en/avideo/VideoEn-Open260718';
import VideoOpen260718Es from '../pages/es/avideo/VideoEs-Open260718';
import VideoOpen260718Ru from '../pages/ru/avideo/VideoRu-Open260718';
import VideoOpen260719En from '../pages/en/avideo/VideoEn-Open260719';
import VideoOpen260719Es from '../pages/es/avideo/VideoEs-Open260719';
import VideoOpen260719Ru from '../pages/ru/avideo/VideoRu-Open260719';
import VideoOpen260720En from '../pages/en/avideo/VideoEn-Open260720';
import VideoOpen260720Es from '../pages/es/avideo/VideoEs-Open260720';
import VideoOpen260720Ru from '../pages/ru/avideo/VideoRu-Open260720';
import VideoOpen260721En from '../pages/en/avideo/VideoEn-Open260721';
import VideoOpen260721Es from '../pages/es/avideo/VideoEs-Open260721';
import VideoOpen260721Ru from '../pages/ru/avideo/VideoRu-Open260721';
import VideoOpen260722En from '../pages/en/avideo/VideoEn-Open260722';
import VideoOpen260722Es from '../pages/es/avideo/VideoEs-Open260722';
import VideoOpen260722Ru from '../pages/ru/avideo/VideoRu-Open260722';
import VideoOpen260723En from '../pages/en/avideo/VideoEn-Open260723';
import VideoOpen260723Es from '../pages/es/avideo/VideoEs-Open260723';
import VideoOpen260723Ru from '../pages/ru/avideo/VideoRu-Open260723';
import VideoOpen260724En from '../pages/en/avideo/VideoEn-Open260724';
import VideoOpen260724Es from '../pages/es/avideo/VideoEs-Open260724';
import VideoOpen260724Ru from '../pages/ru/avideo/VideoRu-Open260724';
import VideoOpen260725En from '../pages/en/avideo/VideoEn-Open260725';
import VideoOpen260725Es from '../pages/es/avideo/VideoEs-Open260725';
import VideoOpen260725Ru from '../pages/ru/avideo/VideoRu-Open260725';
import VideoOpen260727En from '../pages/en/avideo/VideoEn-Open260727';
import VideoOpen260727Es from '../pages/es/avideo/VideoEs-Open260727';
import VideoOpen260727Ru from '../pages/ru/avideo/VideoRu-Open260727';
import VideoOpen260730En from '../pages/en/avideo/VideoEn-Open260730';
import VideoOpen260730Es from '../pages/es/avideo/VideoEs-Open260730';
import VideoOpen260730Ru from '../pages/ru/avideo/VideoRu-Open260730';
import VideoOpen260731En from '../pages/en/avideo/VideoEn-Open260731';
import VideoOpen260731Es from '../pages/es/avideo/VideoEs-Open260731';
import VideoOpen260731Ru from '../pages/ru/avideo/VideoRu-Open260731';
import VideoOpen260801En from '../pages/en/avideo/VideoEn-Open260801';
import VideoOpen260801Es from '../pages/es/avideo/VideoEs-Open260801';
import VideoOpen260801Ru from '../pages/ru/avideo/VideoRu-Open260801';
import VideoOpen260802En from '../pages/en/avideo/VideoEn-Open260802';
import VideoOpen260802Es from '../pages/es/avideo/VideoEs-Open260802';
import VideoOpen260802Ru from '../pages/ru/avideo/VideoRu-Open260802';
import VideoOpen260803En from '../pages/en/avideo/VideoEn-Open260803';
import VideoOpen260803Es from '../pages/es/avideo/VideoEs-Open260803';
import VideoOpen260803Ru from '../pages/ru/avideo/VideoRu-Open260803';
import VideoOpen260804En from '../pages/en/avideo/VideoEn-Open260804';
import VideoOpen260804Es from '../pages/es/avideo/VideoEs-Open260804';
import VideoOpen260804Ru from '../pages/ru/avideo/VideoRu-Open260804';
import VideoOpen260805En from '../pages/en/avideo/VideoEn-Open260805';
import VideoOpen260805Es from '../pages/es/avideo/VideoEs-Open260805';
import VideoOpen260805Ru from '../pages/ru/avideo/VideoRu-Open260805';
import VideoOpen260806En from '../pages/en/avideo/VideoEn-Open260806';
import VideoOpen260806Es from '../pages/es/avideo/VideoEs-Open260806';
import VideoOpen260806Ru from '../pages/ru/avideo/VideoRu-Open260806';
import VideoOpen260807En from '../pages/en/avideo/VideoEn-Open260807';
import VideoOpen260807Es from '../pages/es/avideo/VideoEs-Open260807';
import VideoOpen260807Ru from '../pages/ru/avideo/VideoRu-Open260807';
import VideoOpen260808En from '../pages/en/avideo/VideoEn-Open260808';
import VideoOpen260808Es from '../pages/es/avideo/VideoEs-Open260808';
import VideoOpen260808Ru from '../pages/ru/avideo/VideoRu-Open260808';
import VideoOpen260809En from '../pages/en/avideo/VideoEn-Open260809';
import VideoOpen260809Es from '../pages/es/avideo/VideoEs-Open260809';
import VideoOpen260809Ru from '../pages/ru/avideo/VideoRu-Open260809';
import VideoOpen260810En from '../pages/en/avideo/VideoEn-Open260810';
import VideoOpen260810Es from '../pages/es/avideo/VideoEs-Open260810';
import VideoOpen260810Ru from '../pages/ru/avideo/VideoRu-Open260810';
import VideoOpen260812En from '../pages/en/avideo/VideoEn-Open260812';
import VideoOpen260812Es from '../pages/es/avideo/VideoEs-Open260812';
import VideoOpen260812Ru from '../pages/ru/avideo/VideoRu-Open260812';
import VideoOpen260814En from '../pages/en/avideo/VideoEn-Open260814';
import VideoOpen260814Es from '../pages/es/avideo/VideoEs-Open260814';
import VideoOpen260814Ru from '../pages/ru/avideo/VideoRu-Open260814';
import VideoOpen260815En from '../pages/en/avideo/VideoEn-Open260815';
import VideoOpen260815Es from '../pages/es/avideo/VideoEs-Open260815';
import VideoOpen260815Ru from '../pages/ru/avideo/VideoRu-Open260815';
import VideoOpen260816En from '../pages/en/avideo/VideoEn-Open260816';
import VideoOpen260816Es from '../pages/es/avideo/VideoEs-Open260816';
import VideoOpen260816Ru from '../pages/ru/avideo/VideoRu-Open260816';
import VideoOpen260817En from '../pages/en/avideo/VideoEn-Open260817';
import VideoOpen260817Es from '../pages/es/avideo/VideoEs-Open260817';
import VideoOpen260817Ru from '../pages/ru/avideo/VideoRu-Open260817';
import VideoOpen260818En from '../pages/en/avideo/VideoEn-Open260818';
import VideoOpen260818Es from '../pages/es/avideo/VideoEs-Open260818';
import VideoOpen260818Ru from '../pages/ru/avideo/VideoRu-Open260818';
import VideoOpen260819En from '../pages/en/avideo/VideoEn-Open260819';
import VideoOpen260819Es from '../pages/es/avideo/VideoEs-Open260819';
import VideoOpen260819Ru from '../pages/ru/avideo/VideoRu-Open260819';
import VideoOpen260820En from '../pages/en/avideo/VideoEn-Open260820';
import VideoOpen260820Es from '../pages/es/avideo/VideoEs-Open260820';
import VideoOpen260820Ru from '../pages/ru/avideo/VideoRu-Open260820';
import VideoOpen260821En from '../pages/en/avideo/VideoEn-Open260821';
import VideoOpen260821Es from '../pages/es/avideo/VideoEs-Open260821';
import VideoOpen260821Ru from '../pages/ru/avideo/VideoRu-Open260821';
import VideoOpen260822En from '../pages/en/avideo/VideoEn-Open260822';
import VideoOpen260822Es from '../pages/es/avideo/VideoEs-Open260822';
import VideoOpen260822Ru from '../pages/ru/avideo/VideoRu-Open260822';
import VideoOpen260823En from '../pages/en/avideo/VideoEn-Open260823';
import VideoOpen260823Es from '../pages/es/avideo/VideoEs-Open260823';
import VideoOpen260823Ru from '../pages/ru/avideo/VideoRu-Open260823';
import VideoOpen260824En from '../pages/en/avideo/VideoEn-Open260824';
import VideoOpen260824Es from '../pages/es/avideo/VideoEs-Open260824';
import VideoOpen260824Ru from '../pages/ru/avideo/VideoRu-Open260824';
import VideoOpen260826En from '../pages/en/avideo/VideoEn-Open260826';
import VideoOpen260826Es from '../pages/es/avideo/VideoEs-Open260826';
import VideoOpen260826Ru from '../pages/ru/avideo/VideoRu-Open260826';
import VideoOpen260827En from '../pages/en/avideo/VideoEn-Open260827';
import VideoOpen260827Es from '../pages/es/avideo/VideoEs-Open260827';
import VideoOpen260827Ru from '../pages/ru/avideo/VideoRu-Open260827';
import VideoOpen260828En from '../pages/en/avideo/VideoEn-Open260828';
import VideoOpen260828Es from '../pages/es/avideo/VideoEs-Open260828';
import VideoOpen260828Ru from '../pages/ru/avideo/VideoRu-Open260828';
import VideoOpen260829En from '../pages/en/avideo/VideoEn-Open260829';
import VideoOpen260829Es from '../pages/es/avideo/VideoEs-Open260829';
import VideoOpen260829Ru from '../pages/ru/avideo/VideoRu-Open260829';
import VideoOpen260831En from '../pages/en/avideo/VideoEn-Open260831';
import VideoOpen260831Es from '../pages/es/avideo/VideoEs-Open260831';
import VideoOpen260831Ru from '../pages/ru/avideo/VideoRu-Open260831';
import VideoOpen260901En from '../pages/en/avideo/VideoEn-Open260901';
import VideoOpen260901Es from '../pages/es/avideo/VideoEs-Open260901';
import VideoOpen260901Ru from '../pages/ru/avideo/VideoRu-Open260901';
import VideoOpen260902En from '../pages/en/avideo/VideoEn-Open260902';
import VideoOpen260902Es from '../pages/es/avideo/VideoEs-Open260902';
import VideoOpen260902Ru from '../pages/ru/avideo/VideoRu-Open260902';
import VideoOpen260903En from '../pages/en/avideo/VideoEn-Open260903';
import VideoOpen260903Es from '../pages/es/avideo/VideoEs-Open260903';
import VideoOpen260903Ru from '../pages/ru/avideo/VideoRu-Open260903';
import VideoOpen260904En from '../pages/en/avideo/VideoEn-Open260904';
import VideoOpen260904Es from '../pages/es/avideo/VideoEs-Open260904';
import VideoOpen260904Ru from '../pages/ru/avideo/VideoRu-Open260904';
import VideoOpen260905En from '../pages/en/avideo/VideoEn-Open260905';
import VideoOpen260905Es from '../pages/es/avideo/VideoEs-Open260905';
import VideoOpen260905Ru from '../pages/ru/avideo/VideoRu-Open260905';
import VideoOpen260909En from '../pages/en/avideo/VideoEn-Open260909';
import VideoOpen260909Es from '../pages/es/avideo/VideoEs-Open260909';
import VideoOpen260909Ru from '../pages/ru/avideo/VideoRu-Open260909';
import VideoOpen260910En from '../pages/en/avideo/VideoEn-Open260910';
import VideoOpen260910Es from '../pages/es/avideo/VideoEs-Open260910';
import VideoOpen260910Ru from '../pages/ru/avideo/VideoRu-Open260910';
import VideoOpen260911En from '../pages/en/avideo/VideoEn-Open260911';
import VideoOpen260911Es from '../pages/es/avideo/VideoEs-Open260911';
import VideoOpen260911Ru from '../pages/ru/avideo/VideoRu-Open260911';
import VideoOpen260912En from '../pages/en/avideo/VideoEn-Open260912';
import VideoOpen260912Es from '../pages/es/avideo/VideoEs-Open260912';
import VideoOpen260912Ru from '../pages/ru/avideo/VideoRu-Open260912';
import VideoOpen260913En from '../pages/en/avideo/VideoEn-Open260913';
import VideoOpen260913Es from '../pages/es/avideo/VideoEs-Open260913';
import VideoOpen260913Ru from '../pages/ru/avideo/VideoRu-Open260913';
import VideoOpen260915En from '../pages/en/avideo/VideoEn-Open260915';
import VideoOpen260915Es from '../pages/es/avideo/VideoEs-Open260915';
import VideoOpen260915Ru from '../pages/ru/avideo/VideoRu-Open260915';
import VideoOpen260916En from '../pages/en/avideo/VideoEn-Open260916';
import VideoOpen260916Es from '../pages/es/avideo/VideoEs-Open260916';
import VideoOpen260916Ru from '../pages/ru/avideo/VideoRu-Open260916';
import VideoOpen260917En from '../pages/en/avideo/VideoEn-Open260917';
import VideoOpen260917Es from '../pages/es/avideo/VideoEs-Open260917';
import VideoOpen260917Ru from '../pages/ru/avideo/VideoRu-Open260917';
import VideoOpen260918En from '../pages/en/avideo/VideoEn-Open260918';
import VideoOpen260918Es from '../pages/es/avideo/VideoEs-Open260918';
import VideoOpen260918Ru from '../pages/ru/avideo/VideoRu-Open260918';
import VideoOpen260919En from '../pages/en/avideo/VideoEn-Open260919';
import VideoOpen260919Es from '../pages/es/avideo/VideoEs-Open260919';
import VideoOpen260919Ru from '../pages/ru/avideo/VideoRu-Open260919';
import VideoOpen260920En from '../pages/en/avideo/VideoEn-Open260920';
import VideoOpen260920Es from '../pages/es/avideo/VideoEs-Open260920';
import VideoOpen260920Ru from '../pages/ru/avideo/VideoRu-Open260920';
import VideoOpen260921En from '../pages/en/avideo/VideoEn-Open260921';
import VideoOpen260921Es from '../pages/es/avideo/VideoEs-Open260921';
import VideoOpen260921Ru from '../pages/ru/avideo/VideoRu-Open260921';
import VideoOpen260926En from '../pages/en/avideo/VideoEn-Open260926';
import VideoOpen260926Es from '../pages/es/avideo/VideoEs-Open260926';
import VideoOpen260926Ru from '../pages/ru/avideo/VideoRu-Open260926';
import VideoOpen260927En from '../pages/en/avideo/VideoEn-Open260927';
import VideoOpen260927Es from '../pages/es/avideo/VideoEs-Open260927';
import VideoOpen260927Ru from '../pages/ru/avideo/VideoRu-Open260927';
import VideoOpen261003En from '../pages/en/avideo/VideoEn-Open261003';
import VideoOpen261003Es from '../pages/es/avideo/VideoEs-Open261003';
import VideoOpen261003Ru from '../pages/ru/avideo/VideoRu-Open261003';
import VideoOpen261004En from '../pages/en/avideo/VideoEn-Open261004';
import VideoOpen261004Es from '../pages/es/avideo/VideoEs-Open261004';
import VideoOpen261004Ru from '../pages/ru/avideo/VideoRu-Open261004';
import VideoOpen261010En from '../pages/en/avideo/VideoEn-Open261010';
import VideoOpen261010Es from '../pages/es/avideo/VideoEs-Open261010';
import VideoOpen261010Ru from '../pages/ru/avideo/VideoRu-Open261010';
import VideoOpen261011En from '../pages/en/avideo/VideoEn-Open261011';
import VideoOpen261011Es from '../pages/es/avideo/VideoEs-Open261011';
import VideoOpen261011Ru from '../pages/ru/avideo/VideoRu-Open261011';
import VideoOpen261016En from '../pages/en/avideo/VideoEn-Open261016';
import VideoOpen261016Es from '../pages/es/avideo/VideoEs-Open261016';
import VideoOpen261016Ru from '../pages/ru/avideo/VideoRu-Open261016';
import VideoOpen261018En from '../pages/en/avideo/VideoEn-Open261018';
import VideoOpen261018Es from '../pages/es/avideo/VideoEs-Open261018';
import VideoOpen261018Ru from '../pages/ru/avideo/VideoRu-Open261018';
import VideoOpen261025En from '../pages/en/avideo/VideoEn-Open261025';
import VideoOpen261025Es from '../pages/es/avideo/VideoEs-Open261025';
import VideoOpen261025Ru from '../pages/ru/avideo/VideoRu-Open261025';




const Constants = {
  en: {
    Home: HomeEn,
    Menu: MenuEn,
    About: AboutEn,
    Contact: ContactEn,
    Support: SupportEn,

    EventsCulture: EventsCultureEn,
    EventsDance: EventsDanceEn,
    EventSpanish: EventSpanishEn,
    Gallery: GalleryEn,
    Photos: PhotosEn,
    Projects: ProjectsEn,
    RestaHome: RestaHomeEn,
    SchoolsDance: SchoolsDanceEn,
    SchoolsSpanish: SchoolsSpanishEn,
    SpanishLanguage: SpanishLanguageEn,
    Store: StoreEn,
    TeachersDance: TeachersDanceEn,
    TeacherSpanish: TeacherSpanishEn,
    VideoEvents: VideoEventsEn,

    LatinoDanceMoscow: LatinoDanceMoscowEn,
    OpenAirMoscow: OpenAirMoscowEn,
    LatinaFestMoscow:LatinaFestMoscowEn,

    Photo240509: Photo240509En,
    StoreAlpaca: StoreAlpacaEn,
    StorePeru: StorePeruEn,

    Salsateca: SalsatecaEn,

    VideoOpen240518: VideoOpen240518En,
    VideoOpen240519: VideoOpen240519En,
    VideoOpen240525: VideoOpen240525En,
    VideoOpen240528: VideoOpen240528En,
    VideoOpen240530: VideoOpen240530En,
    VideoOpen240531: VideoOpen240531En,
    VideoOpen240602: VideoOpen240602En,
    VideoOpen240607: VideoOpen240607En,
    VideoOpen240608: VideoOpen240608En,
    VideoOpen240609: VideoOpen240609En,
    VideoOpen240614: VideoOpen240614En,
    VideoOpen240615: VideoOpen240615En,
    VideoOpen240616: VideoOpen240616En,
    VideoOpen240619: VideoOpen240619En,
    VideoOpen240621: VideoOpen240621En,
    VideoOpen240622: VideoOpen240622En,
    VideoOpen240623: VideoOpen240623En,
    VideoOpen240625: VideoOpen240625En,
    VideoOpen240626: VideoOpen240626En,
    VideoOpen240628: VideoOpen240628En,
    VideoOpen240629: VideoOpen240629En,
    VideoOpen240630: VideoOpen240630En,
    VideoOpen240701: VideoOpen240701En,
    VideoOpen240702: VideoOpen240702En,
    VideoOpen240703: VideoOpen240703En,
    VideoOpen240706: VideoOpen240706En,
    VideoOpen240707: VideoOpen240707En,
    VideoOpen240709: VideoOpen240709En,
    VideoOpen240710: VideoOpen240710En,
    VideoOpen240712: VideoOpen240712En,
    VideoOpen240713: VideoOpen240713En,
    VideoOpen240714: VideoOpen240714En,
    VideoOpen240716: VideoOpen240716En,
    VideoOpen240717: VideoOpen240717En,
    VideoOpen240718: VideoOpen240718En,
    VideoOpen240719: VideoOpen240719En,
    VideoOpen240720: VideoOpen240720En,
    VideoOpen240723: VideoOpen240723En,
    VideoOpen240725: VideoOpen240725En,
    VideoOpen240731: VideoOpen240731En,
    VideoOpen240801: VideoOpen240801En,
    VideoOpen240802: VideoOpen240802En,
    VideoOpen240803: VideoOpen240803En,
    VideoOpen240804: VideoOpen240804En,
    VideoOpen240806: VideoOpen240806En,
    VideoOpen240807: VideoOpen240807En,
    VideoOpen240808: VideoOpen240808En,
    VideoOpen240809: VideoOpen240809En,
    VideoOpen240810: VideoOpen240810En,
    VideoOpen240813: VideoOpen240813En,
    VideoOpen240814: VideoOpen240814En,
    VideoOpen240815: VideoOpen240815En,
    VideoOpen240816: VideoOpen240816En,
    VideoOpen240820: VideoOpen240820En,
    VideoOpen240821: VideoOpen240821En,
    VideoOpen240822: VideoOpen240822En,
    VideoOpen240823: VideoOpen240823En,
    VideoOpen240824: VideoOpen240824En,
    VideoOpen240825: VideoOpen240825En,
    VideoOpenShip: VideoOpenShipEn,
    VideoOpen240827: VideoOpen240827En,
    VideoOpen240828: VideoOpen240828En,
    VideoOpen240830: VideoOpen240830En,
    VideoOpen240831: VideoOpen240831En,
    VideoOpen240901: VideoOpen240901En,
    VideoOpen240903: VideoOpen240903En,
    VideoOpen240904: VideoOpen240904En,
    VideoOpen240905: VideoOpen240905En,
    VideoOpen240906: VideoOpen240906En,
    VideoOpen240907: VideoOpen240907En,
    VideoOpen240908: VideoOpen240908En,
    VideoOpen240910: VideoOpen240910En,
    VideoOpen240911: VideoOpen240911En,
    VideoOpen240912: VideoOpen240912En,
    VideoOpen240913: VideoOpen240913En,
    VideoOpen240914: VideoOpen240914En,
    VideoOpen240915: VideoOpen240915En,
    VideoOpen240916: VideoOpen240916En,
    VideoOpen240917: VideoOpen240917En,
    VideoOpen240918: VideoOpen240918En,
    VideoOpen240919: VideoOpen240919En,
    VideoOpen240921: VideoOpen240921En,    
    VideoOpen240925: VideoOpen240925En,
    VideoOpen240926: VideoOpen240926En,
    VideoBrillo241009: VideoBrillo241009En,
    VideoBrillo241017: VideoBrillo241017En,
    VideoBrillo241031: VideoBrillo241031En,
    VideoBrillo241114: VideoBrillo241114En,
    VideoBrillo241121: VideoBrillo241121En,
    VideoBrillo241128: VideoBrillo241128En,
    VideoBrillo241205: VideoBrillo241205En,
    VideoBrillo241226: VideoBrillo241226En,
    VideoWDance250125: VideoWDance250125En,
    VideoOpen250418: VideoOpen250418En,
    VideoOpen250419: VideoOpen250419En,
    VideoOpen250522: VideoOpen250522En,
    VideoOpen250523: VideoOpen250523En,
    VideoOpen250524: VideoOpen250524En,
    VideoTardeo250524: VideoTardeo250524En,
    VideoOpen250525: VideoOpen250525En,
    VideoOpen250528: VideoOpen250528En,
    VideoOpen250529: VideoOpen250529En,
    VideoOpen250530: VideoOpen250530En,
    VideoOpen250531: VideoOpen250531En,
    VideoOpen250601: VideoOpen250601En,
    VideoOpen250604: VideoOpen250604En,
    VideoOpen250605: VideoOpen250605En,
    VideoOpen250606: VideoOpen250606En,
    VideoOpen250607: VideoOpen250607En,
    VideoOpen250611: VideoOpen250611En,
    VideoOpen250612: VideoOpen250612En,
    VideoOpen250616: VideoOpen250616En,
    VideoOpen250623: VideoOpen250623En,
    VideoOpen250625: VideoOpen250625En,
    VideoOpen250628: VideoOpen250628En,
    VideoOpen250702: VideoOpen250702En,
    VideoOpen250703: VideoOpen250703En,
    VideoOpen250704: VideoOpen250704En,
    VideoOpen250705: VideoOpen250705En,
    VideoOpen250706: VideoOpen250706En,
    VideoOpen250707: VideoOpen250707En,
    VideoOpen250709: VideoOpen250709En,
    VideoOpen250710: VideoOpen250710En,
    VideoOpen250711: VideoOpen250711En,
    VideoOpen250712: VideoOpen250712En,
    VideoOpen250713: VideoOpen250713En,
    VideoOpen250714: VideoOpen250714En,
    VideoOpen250716: VideoOpen250716En,
    VideoOpen250717: VideoOpen250717En,
    VideoOpen250718: VideoOpen250718En,
    VideoOpen250720: VideoOpen250720En,
    VideoOpen250721: VideoOpen250721En,
    VideoOpen250722: VideoOpen250722En,
    VideoOpen250723: VideoOpen250723En,
    VideoOpen250725: VideoOpen250725En,
    VideoOpen250726: VideoOpen250726En,
    VideoOpen250727: VideoOpen250727En,
    VideoOpen250728: VideoOpen250728En,
    VideoOpen250729: VideoOpen250729En,
    VideoOpen250730: VideoOpen250730En,
    VideoOpen250731: VideoOpen250731En,
    VideoOpen250801: VideoOpen250801En,
    VideoOpen250802: VideoOpen250802En,
    VideoOpen250803: VideoOpen250803En,
    VideoOpen250805: VideoOpen250805En,
    VideoOpen250806: VideoOpen250806En,
    VideoOpen250807: VideoOpen250807En,
    VideoOpen250809: VideoOpen250809En,
    VideoOpen250810: VideoOpen250810En,
    VideoOpen250813: VideoOpen250813En,
    VideoOpen250814: VideoOpen250814En,
    VideoOpen250816: VideoOpen250816En,
    VideoOpen250817: VideoOpen250817En,
    VideoOpen250821: VideoOpen250821En,
    VideoOpen250823: VideoOpen250823En,  
    VideoOpen250824: VideoOpen250824En,
    VideoOpen250825: VideoOpen250825En,
    VideoOpen250827: VideoOpen250827En,
    VideoOpen250828: VideoOpen250828En,
    VideoOpen250830: VideoOpen250830En,
    VideoOpen250831: VideoOpen250831En,
    VideoOpen250901: VideoOpen250901En,
    VideoOpen250903: VideoOpen250903En,
    VideoOpen250904: VideoOpen250904En,
    VideoOpen250906: VideoOpen250906En,
    VideoOpen250907: VideoOpen250907En,
    VideoOpen250908: VideoOpen250908En,
    VideoOpen250910: VideoOpen250910En,
    VideoOpen250911: VideoOpen250911En,
    VideoOpen250913: VideoOpen250913En,
    VideoOpen250914: VideoOpen250914En,
    VideoOpen250915: VideoOpen250915En,
    VideoOpen250917: VideoOpen250917En,
    VideoOpen250920: VideoOpen250920En,
    VideoOpen250921: VideoOpen250921En,
    VideoOpen250922: VideoOpen250922En,
    VideoOpen250928: VideoOpen250928En,
    VideoOpen251005: VideoOpen251005En,
    VideoOpen251012: VideoOpen251012En,
    VideoOpen251019: VideoOpen251019En,
    VideoOpen251026: VideoOpen251026En,
    VideoOpen251102: VideoOpen251102En,
    VideoOpen251109: VideoOpen251109En,
    VideoOpen251116: VideoOpen251116En,
    VideoOpen251123: VideoOpen251123En,
    VideoOpen251130: VideoOpen251130En,
    VideoOpen251214: VideoOpen251214En,
    VideoOpen251221: VideoOpen251221En,
    VideoOpen251228: VideoOpen251228En,
    VideoOpen260104: VideoOpen260104En,
    VideoOpen260111: VideoOpen260111En,
    VideoOpen260118: VideoOpen260118En,
    VideoOpen260125: VideoOpen260125En,
    VideoOpen260201: VideoOpen260201En,
    VideoOpen260215: VideoOpen260215En,
    VideoOpen260222: VideoOpen260222En,
    VideoOpen260301: VideoOpen260301En,
    VideoOpen260308: VideoOpen260308En,
    VideoOpen260315: VideoOpen260315En,
    VideoOpen260322: VideoOpen260322En,
    VideoOpen260329: VideoOpen260329En,
    VideoOpen260405: VideoOpen260405En,
    VideoOpen260412: VideoOpen260412En,
    VideoOpen260419: VideoOpen260419En,
    VideoOpen260426: VideoOpen260426En,
    VideoOpen260503: VideoOpen260503En,
    VideoOpen260506: VideoOpen260506En,
    VideoOpen260509: VideoOpen260509En,
    VideoOpen260510: VideoOpen260510En,
    VideoOpen260512: VideoOpen260512En,
    VideoOpen260513: VideoOpen260513En,
    VideoOpen260514: VideoOpen260514En,
    VideoOpen260516: VideoOpen260516En,
    VideoOpen260517: VideoOpen260517En,
    VideoOpen260518: VideoOpen260518En,
    VideoOpen260519: VideoOpen260519En,
    VideoOpen260520: VideoOpen260520En,
    VideoOpen260521: VideoOpen260521En,
    VideoOpen260522: VideoOpen260522En,
    VideoOpen260523: VideoOpen260523En,
    VideoOpen260524: VideoOpen260524En,
    VideoOpen260530: VideoOpen260530En,
    VideoOpen260531: VideoOpen260531En,
    VideoOpen260601: VideoOpen260601En,
    VideoOpen260602: VideoOpen260602En,
    VideoOpen260603: VideoOpen260603En,
    VideoOpen260604: VideoOpen260604En,
    VideoOpen260605: VideoOpen260605En,
    VideoOpen260606: VideoOpen260606En,
    VideoOpen260607: VideoOpen260607En,
    VideoOpen260608: VideoOpen260608En,
    VideoOpen260609: VideoOpen260609En,
    VideoOpen260610: VideoOpen260610En,
    VideoOpen260611: VideoOpen260611En,
    VideoOpen260612: VideoOpen260612En,
    VideoOpen260614: VideoOpen260614En,
    VideoOpen260617: VideoOpen260617En,
    VideoOpen260620: VideoOpen260620En,
    VideoOpen260621: VideoOpen260621En,
    VideoOpen260622: VideoOpen260622En,
    VideoOpen260623: VideoOpen260623En,
    VideoOpen260624: VideoOpen260624En,
    VideoOpen260625: VideoOpen260625En,
    VideoOpen260626: VideoOpen260626En,
    VideoOpen260627: VideoOpen260627En,
    VideoOpen260628: VideoOpen260628En,
    VideoOpen260629: VideoOpen260629En,
    VideoOpen260701: VideoOpen260701En,
    VideoOpen260702: VideoOpen260702En,
    VideoOpen260703: VideoOpen260703En,
    VideoOpen260704: VideoOpen260704En,
    VideoOpen260705: VideoOpen260705En,
    VideoOpen260706: VideoOpen260706En,
    VideoOpen260708: VideoOpen260708En,
    VideoOpen260709: VideoOpen260709En,
    VideoOpen260710: VideoOpen260710En,
    VideoOpen260711: VideoOpen260711En,
    VideoOpen260713: VideoOpen260713En,
    VideoOpen260714: VideoOpen260714En,
    VideoOpen260715: VideoOpen260715En,
    VideoOpen260716: VideoOpen260716En,
    VideoOpen260717: VideoOpen260717En,
    VideoOpen260718: VideoOpen260718En,
    VideoOpen260719: VideoOpen260719En,
    VideoOpen260720: VideoOpen260720En,
    VideoOpen260721: VideoOpen260721En,
    VideoOpen260722: VideoOpen260722En,
    VideoOpen260723: VideoOpen260723En,
    VideoOpen260724: VideoOpen260724En,
    VideoOpen260725: VideoOpen260725En,
    VideoOpen260727: VideoOpen260727En,
    VideoOpen260730: VideoOpen260730En,
    VideoOpen260731: VideoOpen260731En,
    VideoOpen260801: VideoOpen260801En,
    VideoOpen260802: VideoOpen260802En,
    VideoOpen260803: VideoOpen260803En,
    VideoOpen260804: VideoOpen260804En,
    VideoOpen260805: VideoOpen260805En,
    VideoOpen260806: VideoOpen260806En,
    VideoOpen260807: VideoOpen260807En,
    VideoOpen260808: VideoOpen260808En,
    VideoOpen260809: VideoOpen260809En,
    VideoOpen260810: VideoOpen260810En,
    VideoOpen260812: VideoOpen260812En,
    VideoOpen260814: VideoOpen260814En,
    VideoOpen260815: VideoOpen260815En,
    VideoOpen260816: VideoOpen260816En,
    VideoOpen260817: VideoOpen260817En,
    VideoOpen260818: VideoOpen260818En,
    VideoOpen260819: VideoOpen260819En,
    VideoOpen260820: VideoOpen260820En,
    VideoOpen260821: VideoOpen260821En,
    VideoOpen260822: VideoOpen260822En,
    VideoOpen260823: VideoOpen260823En,
    VideoOpen260824: VideoOpen260824En,
    VideoOpen260826: VideoOpen260826En,
    VideoOpen260827: VideoOpen260827En,
    VideoOpen260828: VideoOpen260828En,
    VideoOpen260829: VideoOpen260829En,
    VideoOpen260831: VideoOpen260831En,
    VideoOpen260901: VideoOpen260901En,
    VideoOpen260902: VideoOpen260902En,
    VideoOpen260903: VideoOpen260903En,
    VideoOpen260904: VideoOpen260904En,
    VideoOpen260905: VideoOpen260905En,
    VideoOpen260909: VideoOpen260909En,
    VideoOpen260910: VideoOpen260910En,
    VideoOpen260911: VideoOpen260911En,
    VideoOpen260912: VideoOpen260912En,
    VideoOpen260913: VideoOpen260913En,
    VideoOpen260915: VideoOpen260915En,
    VideoOpen260916: VideoOpen260916En,
    VideoOpen260917: VideoOpen260917En,
    VideoOpen260918: VideoOpen260918En,
    VideoOpen260919: VideoOpen260919En,
    VideoOpen260920: VideoOpen260920En,
    VideoOpen260921: VideoOpen260921En,
    VideoOpen260926: VideoOpen260926En,
    VideoOpen260927: VideoOpen260927En,
    VideoOpen261003: VideoOpen261003En,
    VideoOpen261004: VideoOpen261004En,
    VideoOpen261010: VideoOpen261010En,
    VideoOpen261011: VideoOpen261011En,
    VideoOpen261016: VideoOpen261016En,
    VideoOpen261018: VideoOpen261018En,
    VideoOpen261025: VideoOpen261025En,
  },

  es: {
    Home: HomeEs,
    Menu: MenuEs,
    About: AboutEs,
    Contact: ContactEs,
    Support: SupportEs,

    Prueba: PruebaEs,
    BlogDetails: BlogDetailsEs,
    Category: CategoryEs,

    EventsCulture: EventsCultureEs,
    EventsDance: EventsDanceEs,
    EventSpanish: EventSpanishEs,
    Gallery: GalleryEs,
    Photos: PhotosEs,
    Projects: ProjectsEs,
    RestaHome: RestaHomeEs,
    SpanishLanguage: SpanishLanguageEs,
    SchoolsDance: SchoolsDanceEs,
    SchoolsSpanish: SchoolsSpanishEs,
    Store: StoreEs,
    TeachersDance: TeachersDanceEs,
    TeacherSpanish: TeacherSpanishEs,
    VideoEvents: VideoEventsEs,

    TurizoLaBachata: TurizoLaBachataEs,
    LatinoDanceMoscow: LatinoDanceMoscowEs,
    TravelToSpain: TravelToSpainEs,
    NewYearLatam: NewYearLatamEs,
    OpenAirMoscow: OpenAirMoscowEs,
    LatinaFestMoscow:LatinaFestMoscowEs,

    Salsateca: SalsatecaEs,

    Photo240509: Photo240509Es,
    StoreAlpaca: StoreAlpacaEs,
    StorePeru: StorePeruEs,

    VideoOpen240518: VideoOpen240518Es,
    VideoOpen240519: VideoOpen240519Es,
    VideoOpen240525: VideoOpen240525Es,
    VideoOpen240528: VideoOpen240528Es,
    VideoOpen240530: VideoOpen240530Es,
    VideoOpen240531: VideoOpen240531Es,
    VideoOpen240602: VideoOpen240602Es,
    VideoOpen240607: VideoOpen240607Es,
    VideoOpen240608: VideoOpen240608Es,
    VideoOpen240609: VideoOpen240609Es,
    VideoOpen240614: VideoOpen240614Es,
    VideoOpen240615: VideoOpen240615Es,
    VideoOpen240616: VideoOpen240616Es,
    VideoOpen240619: VideoOpen240619Es,
    VideoOpen240621: VideoOpen240621Es,
    VideoOpen240622: VideoOpen240622Es,
    VideoOpen240623: VideoOpen240623Es,
    VideoOpen240625: VideoOpen240625Es,
    VideoOpen240626: VideoOpen240626Es,
    VideoOpen240628: VideoOpen240628Es,
    VideoOpen240629: VideoOpen240629Es,
    VideoOpen240630: VideoOpen240630Es,
    VideoOpen240701: VideoOpen240701Es,
    VideoOpen240702: VideoOpen240702Es,
    VideoOpen240703: VideoOpen240703Es,
    VideoOpen240706: VideoOpen240706Es,
    VideoOpen240707: VideoOpen240707Es,
    VideoOpen240709: VideoOpen240709Es,
    VideoOpen240710: VideoOpen240710Es,
    VideoOpen240712: VideoOpen240712Es,
    VideoOpen240713: VideoOpen240713Es,
    VideoOpen240714: VideoOpen240714Es,
    VideoOpen240716: VideoOpen240716Es,
    VideoOpen240717: VideoOpen240717Es,
    VideoOpen240718: VideoOpen240718Es,
    VideoOpen240719: VideoOpen240719Es,
    VideoOpen240720: VideoOpen240720Es,
    VideoOpen240723: VideoOpen240723Es,
    VideoOpen240725: VideoOpen240725Es,
    VideoOpen240731: VideoOpen240731Es,
    VideoOpen240801: VideoOpen240801Es,
    VideoOpen240802: VideoOpen240802Es,
    VideoOpen240803: VideoOpen240803Es,
    VideoOpen240804: VideoOpen240804Es,
    VideoOpen240806: VideoOpen240806Es,
    VideoOpen240807: VideoOpen240807Es,
    VideoOpen240808: VideoOpen240808Es,
    VideoOpen240809: VideoOpen240809Es,
    VideoOpen240810: VideoOpen240810Es,
    VideoOpen240813: VideoOpen240813Es,
    VideoOpen240814: VideoOpen240814Es,
    VideoOpen240815: VideoOpen240815Es,
    VideoOpen240816: VideoOpen240816Es,
    VideoOpen240820: VideoOpen240820Es,
    VideoOpen240821: VideoOpen240821Es,
    VideoOpen240822: VideoOpen240822Es,
    VideoOpen240823: VideoOpen240823Es,
    VideoOpen240824: VideoOpen240824Es,
    VideoOpen240825: VideoOpen240825Es,
    VideoOpenShip: VideoOpenShipEs,
    VideoOpen240827: VideoOpen240827Es,
    VideoOpen240828: VideoOpen240828Es,
    VideoOpen240830: VideoOpen240830Es,
    VideoOpen240831: VideoOpen240831Es,
    VideoOpen240901: VideoOpen240901Es,
    VideoOpen240903: VideoOpen240903Es,
    VideoOpen240904: VideoOpen240904Es,
    VideoOpen240905: VideoOpen240905Es,
    VideoOpen240906: VideoOpen240906Es,
    VideoOpen240907: VideoOpen240907Es,
    VideoOpen240908: VideoOpen240908Es,
    VideoOpen240910: VideoOpen240910Es,
    VideoOpen240911: VideoOpen240911Es,
    VideoOpen240912: VideoOpen240912Es,
    VideoOpen240913: VideoOpen240913Es,
    VideoOpen240914: VideoOpen240914Es,
    VideoOpen240915: VideoOpen240915Es,
    VideoOpen240916: VideoOpen240916Es,
    VideoOpen240917: VideoOpen240917Es,
    VideoOpen240918: VideoOpen240918Es,
    VideoOpen240919: VideoOpen240919Es,
    VideoOpen240921: VideoOpen240921Es,       
    VideoOpen240925: VideoOpen240925Es,
    VideoOpen240926: VideoOpen240926Es,
    VideoBrillo241009: VideoBrillo241009Es,
    VideoBrillo241017: VideoBrillo241017Es,
    VideoBrillo241031: VideoBrillo241031Es,
    VideoBrillo241114: VideoBrillo241114Es,
    VideoBrillo241121: VideoBrillo241121Es,
    VideoBrillo241128: VideoBrillo241128Es,
    VideoBrillo241205: VideoBrillo241205Es,
    VideoBrillo241226: VideoBrillo241226Es,
    VideoWDance250125: VideoWDance250125Es,
    VideoOpen250418: VideoOpen250418Es,
    VideoOpen250419: VideoOpen250419Es,
    VideoOpen250522: VideoOpen250522Es,
    VideoOpen250523: VideoOpen250523Es,    
    VideoOpen250524: VideoOpen250524Es,
    VideoTardeo250524: VideoTardeo250524Es,
    VideoOpen250525: VideoOpen250525Es,
    VideoOpen250528: VideoOpen250528Es,
    VideoOpen250529: VideoOpen250529Es,
    VideoOpen250530: VideoOpen250530Es,
    VideoOpen250531: VideoOpen250531Es,
    VideoOpen250601: VideoOpen250601Es,
    VideoOpen250604: VideoOpen250604Es,
    VideoOpen250605: VideoOpen250605Es,
    VideoOpen250606: VideoOpen250606Es,
    VideoOpen250607: VideoOpen250607Es,
    VideoOpen250611: VideoOpen250611Es,
    VideoOpen250612: VideoOpen250612Es,
    VideoOpen250616: VideoOpen250616Es,
    VideoOpen250623: VideoOpen250623Es,
    VideoOpen250625: VideoOpen250625Es,
    VideoOpen250628: VideoOpen250628Es,
    VideoOpen250702: VideoOpen250702Es,
    VideoOpen250703: VideoOpen250703Es,
    VideoOpen250704: VideoOpen250704Es,
    VideoOpen250705: VideoOpen250705Es,
    VideoOpen250706: VideoOpen250706Es,
    VideoOpen250707: VideoOpen250707Es,
    VideoOpen250709: VideoOpen250709Es,
    VideoOpen250710: VideoOpen250710Es,
    VideoOpen250711: VideoOpen250711Es,
    VideoOpen250712: VideoOpen250712Es,
    VideoOpen250713: VideoOpen250713Es,
    VideoOpen250714: VideoOpen250714Es,
    VideoOpen250716: VideoOpen250716Es,
    VideoOpen250717: VideoOpen250717Es,
    VideoOpen250718: VideoOpen250718Es,
    VideoOpen250720: VideoOpen250720Es,
    VideoOpen250721: VideoOpen250721Es,
    VideoOpen250722: VideoOpen250722Es,
    VideoOpen250723: VideoOpen250723Es,
    VideoOpen250725: VideoOpen250725Es,
    VideoOpen250726: VideoOpen250726Es,
    VideoOpen250727: VideoOpen250727Es,
    VideoOpen250728: VideoOpen250728Es,
    VideoOpen250729: VideoOpen250729Es,
    VideoOpen250730: VideoOpen250730Es,
    VideoOpen250731: VideoOpen250731Es,
    VideoOpen250801: VideoOpen250801Es,
    VideoOpen250802: VideoOpen250802Es,
    VideoOpen250803: VideoOpen250803Es,
    VideoOpen250805: VideoOpen250805Es,
    VideoOpen250806: VideoOpen250806Es,
    VideoOpen250807: VideoOpen250807Es,
    VideoOpen250809: VideoOpen250809Es,
    VideoOpen250810: VideoOpen250810Es,
    VideoOpen250813: VideoOpen250813Es,
    VideoOpen250814: VideoOpen250814Es,
    VideoOpen250816: VideoOpen250816Es,
    VideoOpen250817: VideoOpen250817Es,
    VideoOpen250821: VideoOpen250821Es,
    VideoOpen250823: VideoOpen250823Es,
    VideoOpen250824: VideoOpen250824Es,
    VideoOpen250825: VideoOpen250825Es,
    VideoOpen250827: VideoOpen250827Es,
    VideoOpen250828: VideoOpen250828Es,
    VideoOpen250830: VideoOpen250830Es,
    VideoOpen250831: VideoOpen250831Es,
    VideoOpen250901: VideoOpen250901Es,
    VideoOpen250903: VideoOpen250903Es,
    VideoOpen250904: VideoOpen250904Es,
    VideoOpen250906: VideoOpen250906Es,
    VideoOpen250907: VideoOpen250907Es,
    VideoOpen250908: VideoOpen250908Es,
    VideoOpen250910: VideoOpen250910Es,
    VideoOpen250911: VideoOpen250911Es,
    VideoOpen250913: VideoOpen250913Es,
    VideoOpen250914: VideoOpen250914Es,
    VideoOpen250915: VideoOpen250915Es,
    VideoOpen250917: VideoOpen250917Es,
    VideoOpen250920: VideoOpen250920Es,
    VideoOpen250921: VideoOpen250921Es,
    VideoOpen250922: VideoOpen250922Es,
    VideoOpen250928: VideoOpen250928Es,
    VideoOpen251005: VideoOpen251005Es,
    VideoOpen251012: VideoOpen251012Es,
    VideoOpen251019: VideoOpen251019Es,
    VideoOpen251026: VideoOpen251026Es,
    VideoOpen251102: VideoOpen251102Es,
    VideoOpen251109: VideoOpen251109Es,
    VideoOpen251116: VideoOpen251116Es,
    VideoOpen251123: VideoOpen251123Es,
    VideoOpen251130: VideoOpen251130Es,
    VideoOpen251214: VideoOpen251214Es,
    VideoOpen251221: VideoOpen251221Es,
    VideoOpen251228: VideoOpen251228Es,
    VideoOpen260104: VideoOpen260104Es,
    VideoOpen260111: VideoOpen260111Es,
    VideoOpen260118: VideoOpen260118Es,
    VideoOpen260125: VideoOpen260125Es,
    VideoOpen260201: VideoOpen260201Es,
    VideoOpen260215: VideoOpen260215Es,
    VideoOpen260222: VideoOpen260222Es,
    VideoOpen260301: VideoOpen260301Es,
    VideoOpen260308: VideoOpen260308Es,
    VideoOpen260315: VideoOpen260315Es,
    VideoOpen260322: VideoOpen260322Es,
    VideoOpen260329: VideoOpen260329Es,
    VideoOpen260405: VideoOpen260405Es,
    VideoOpen260412: VideoOpen260412Es,
    VideoOpen260419: VideoOpen260419Es,
    VideoOpen260426: VideoOpen260426Es,
    VideoOpen260503: VideoOpen260503Es,
    VideoOpen260506: VideoOpen260506Es,
    VideoOpen260509: VideoOpen260509Es,
    VideoOpen260510: VideoOpen260510Es,
    VideoOpen260512: VideoOpen260512Es,
    VideoOpen260513: VideoOpen260513Es,
    VideoOpen260514: VideoOpen260514Es,
    VideoOpen260516: VideoOpen260516Es,
    VideoOpen260517: VideoOpen260517Es,
    VideoOpen260518: VideoOpen260518Es,
    VideoOpen260519: VideoOpen260519Es,
    VideoOpen260520: VideoOpen260520Es,
    VideoOpen260521: VideoOpen260521Es,
    VideoOpen260522: VideoOpen260522Es,
    VideoOpen260523: VideoOpen260523Es,
    VideoOpen260524: VideoOpen260524Es,
    VideoOpen260530: VideoOpen260530Es,
    VideoOpen260531: VideoOpen260531Es,
    VideoOpen260601: VideoOpen260601Es,
    VideoOpen260602: VideoOpen260602Es,
    VideoOpen260603: VideoOpen260603Es,
    VideoOpen260604: VideoOpen260604Es,
    VideoOpen260605: VideoOpen260605Es,
    VideoOpen260606: VideoOpen260606Es,
    VideoOpen260607: VideoOpen260607Es,
    VideoOpen260608: VideoOpen260608Es,
    VideoOpen260609: VideoOpen260609Es,
    VideoOpen260610: VideoOpen260610Es,
    VideoOpen260611: VideoOpen260611Es,
    VideoOpen260612: VideoOpen260612Es,
    VideoOpen260614: VideoOpen260614Es,
    VideoOpen260617: VideoOpen260617Es,
    VideoOpen260620: VideoOpen260620Es,
    VideoOpen260621: VideoOpen260621Es,
    VideoOpen260622: VideoOpen260622Es,
    VideoOpen260623: VideoOpen260623Es,
    VideoOpen260624: VideoOpen260624Es,
    VideoOpen260625: VideoOpen260625Es,
    VideoOpen260626: VideoOpen260626Es,
    VideoOpen260627: VideoOpen260627Es,
    VideoOpen260628: VideoOpen260628Es,
    VideoOpen260629: VideoOpen260629Es,
    VideoOpen260701: VideoOpen260701Es,
    VideoOpen260702: VideoOpen260702Es,
    VideoOpen260703: VideoOpen260703Es,
    VideoOpen260704: VideoOpen260704Es,
    VideoOpen260705: VideoOpen260705Es,
    VideoOpen260706: VideoOpen260706Es,
    VideoOpen260708: VideoOpen260708Es,
    VideoOpen260709: VideoOpen260709Es,
    VideoOpen260710: VideoOpen260710Es,
    VideoOpen260711: VideoOpen260711Es,
    VideoOpen260713: VideoOpen260713Es,
    VideoOpen260714: VideoOpen260714Es,
    VideoOpen260715: VideoOpen260715Es,
    VideoOpen260716: VideoOpen260716Es,
    VideoOpen260717: VideoOpen260717Es,
    VideoOpen260718: VideoOpen260718Es,
    VideoOpen260719: VideoOpen260719Es,
    VideoOpen260720: VideoOpen260720Es,
    VideoOpen260721: VideoOpen260721Es,
    VideoOpen260722: VideoOpen260722Es,
    VideoOpen260723: VideoOpen260723Es,
    VideoOpen260724: VideoOpen260724Es,
    VideoOpen260725: VideoOpen260725Es,
    VideoOpen260727: VideoOpen260727Es,
    VideoOpen260730: VideoOpen260730Es,
    VideoOpen260731: VideoOpen260731Es,
    VideoOpen260801: VideoOpen260801Es,
    VideoOpen260802: VideoOpen260802Es,
    VideoOpen260803: VideoOpen260803Es,
    VideoOpen260804: VideoOpen260804Es,
    VideoOpen260805: VideoOpen260805Es,
    VideoOpen260806: VideoOpen260806Es,
    VideoOpen260807: VideoOpen260807Es,
    VideoOpen260808: VideoOpen260808Es,
    VideoOpen260809: VideoOpen260809Es,
    VideoOpen260810: VideoOpen260810Es,
    VideoOpen260812: VideoOpen260812Es,
    VideoOpen260814: VideoOpen260814Es,
    VideoOpen260815: VideoOpen260815Es,
    VideoOpen260816: VideoOpen260816Es,
    VideoOpen260817: VideoOpen260817Es,
    VideoOpen260818: VideoOpen260818Es,
    VideoOpen260819: VideoOpen260819Es,
    VideoOpen260820: VideoOpen260820Es,
    VideoOpen260821: VideoOpen260821Es,
    VideoOpen260822: VideoOpen260822Es,
    VideoOpen260823: VideoOpen260823Es,
    VideoOpen260824: VideoOpen260824Es,
    VideoOpen260826: VideoOpen260826Es,
    VideoOpen260827: VideoOpen260827Es,
    VideoOpen260828: VideoOpen260828Es,
    VideoOpen260829: VideoOpen260829Es,
    VideoOpen260831: VideoOpen260831Es,
    VideoOpen260901: VideoOpen260901Es,
    VideoOpen260902: VideoOpen260902Es,
    VideoOpen260903: VideoOpen260903Es,
    VideoOpen260904: VideoOpen260904Es,
    VideoOpen260905: VideoOpen260905Es,
    VideoOpen260909: VideoOpen260909Es,
    VideoOpen260910: VideoOpen260910Es,
    VideoOpen260911: VideoOpen260911Es,
    VideoOpen260912: VideoOpen260912Es,
    VideoOpen260913: VideoOpen260913Es,
    VideoOpen260915: VideoOpen260915Es,
    VideoOpen260916: VideoOpen260916Es,
    VideoOpen260917: VideoOpen260917Es,
    VideoOpen260918: VideoOpen260918Es,
    VideoOpen260919: VideoOpen260919Es,
    VideoOpen260920: VideoOpen260920Es,
    VideoOpen260921: VideoOpen260921Es,
    VideoOpen260926: VideoOpen260926Es,
    VideoOpen260927: VideoOpen260927Es,
    VideoOpen261003: VideoOpen261003Es,
    VideoOpen261004: VideoOpen261004Es,
    VideoOpen261010: VideoOpen261010Es,
    VideoOpen261011: VideoOpen261011Es,
    VideoOpen261016: VideoOpen261016Es,
    VideoOpen261018: VideoOpen261018Es,
    VideoOpen261025: VideoOpen261025Es,
  },

  ru: {
    Home: HomeRu,
    Menu: MenuRu,
    About: AboutRu,
    Contact: ContactRu,
    Support: SupportRu,

    EventsCulture: EventsCultureRu,
    EventsDance: EventsDanceRu,
    EventSpanish: EventSpanishRu,
    Gallery: GalleryRu,
    Photos: PhotosRu,
    Projects: ProjectsRu,
    RestaHome: RestaHomeRu,
    SchoolsDance: SchoolsDanceRu,
    SchoolsSpanish: SchoolsSpanishRu,
    SpanishLanguage: SpanishLanguageRu,
    Store: StoreRu,
    TeachersDance: TeachersDanceRu,
    TeacherSpanish: TeacherSpanishRu,
    VideoEvents: VideoEventsRu,

    TurizoLaBachata: TurizoLaBachataRu,
    LatinoDanceMoscow: LatinoDanceMoscowRu,
    NewYearLatam: NewYearLatamRu,
    TravelToSpain: TravelToSpainRu,
    OpenAirMoscow: OpenAirMoscowRu,
    LatinaFestMoscow:LatinaFestMoscowRu,

    Photo240509: Photo240509Ru,
    StoreAlpaca: StoreAlpacaRu,
    StorePeru: StorePeruRu,

    Salsateca: SalsatecaRu,

    VideoOpen240518: VideoOpen240518Ru,
    VideoOpen240519: VideoOpen240519Ru,
    VideoOpen240525: VideoOpen240525Ru,
    VideoOpen240528: VideoOpen240528Ru,
    VideoOpen240530: VideoOpen240530Ru,
    VideoOpen240531: VideoOpen240531Ru,
    VideoOpen240602: VideoOpen240602Ru,
    VideoOpen240607: VideoOpen240607Ru,
    VideoOpen240608: VideoOpen240608Ru,
    VideoOpen240609: VideoOpen240609Ru,
    VideoOpen240614: VideoOpen240614Ru,
    VideoOpen240615: VideoOpen240615Ru,
    VideoOpen240616: VideoOpen240616Ru,
    VideoOpen240619: VideoOpen240619Ru,
    VideoOpen240621: VideoOpen240621Ru,
    VideoOpen240622: VideoOpen240622Ru,
    VideoOpen240623: VideoOpen240623Ru,
    VideoOpen240625: VideoOpen240625Ru,
    VideoOpen240626: VideoOpen240626Ru,
    VideoOpen240628: VideoOpen240628Ru,
    VideoOpen240629: VideoOpen240629Ru,
    VideoOpen240630: VideoOpen240630Ru,
    VideoOpen240701: VideoOpen240701Ru,
    VideoOpen240702: VideoOpen240702Ru,
    VideoOpen240703: VideoOpen240703Ru,
    VideoOpen240706: VideoOpen240706Ru,
    VideoOpen240707: VideoOpen240707Ru,
    VideoOpen240709: VideoOpen240709Ru,
    VideoOpen240710: VideoOpen240710Ru,
    VideoOpen240712: VideoOpen240712Ru,
    VideoOpen240713: VideoOpen240713Ru,
    VideoOpen240714: VideoOpen240714Ru,
    VideoOpen240716: VideoOpen240716Ru,
    VideoOpen240717: VideoOpen240717Ru,
    VideoOpen240718: VideoOpen240718Ru,
    VideoOpen240719: VideoOpen240719Ru,
    VideoOpen240720: VideoOpen240720Ru,
    VideoOpen240723: VideoOpen240723Ru,
    VideoOpen240725: VideoOpen240725Ru,
    VideoOpen240731: VideoOpen240731Ru,
    VideoOpen240801: VideoOpen240801Ru,
    VideoOpen240802: VideoOpen240802Ru,
    VideoOpen240803: VideoOpen240803Ru,
    VideoOpen240804: VideoOpen240804Ru,
    VideoOpen240806: VideoOpen240806Ru,
    VideoOpen240807: VideoOpen240807Ru,
    VideoOpen240808: VideoOpen240808Ru,
    VideoOpen240809: VideoOpen240809Ru,
    VideoOpen240810: VideoOpen240810Ru,
    VideoOpen240813: VideoOpen240813Ru,
    VideoOpen240814: VideoOpen240814Ru,
    VideoOpen240815: VideoOpen240815Ru,
    VideoOpen240816: VideoOpen240816Ru,
    VideoOpen240820: VideoOpen240820Ru,
    VideoOpen240821: VideoOpen240821Ru,
    VideoOpen240822: VideoOpen240822Ru,
    VideoOpen240823: VideoOpen240823Ru,
    VideoOpen240824: VideoOpen240824Ru,
    VideoOpen240825: VideoOpen240825Ru,
    VideoOpenShip: VideoOpenShipRu,
    VideoOpen240827: VideoOpen240827Ru,
    VideoOpen240828: VideoOpen240828Ru,
    VideoOpen240830: VideoOpen240830Ru,
    VideoOpen240831: VideoOpen240831Ru,
    VideoOpen240901: VideoOpen240901Ru,
    VideoOpen240903: VideoOpen240903Ru,
    VideoOpen240904: VideoOpen240904Ru,
    VideoOpen240905: VideoOpen240905Ru,
    VideoOpen240906: VideoOpen240906Ru,
    VideoOpen240907: VideoOpen240907Ru,
    VideoOpen240908: VideoOpen240908Ru,
    VideoOpen240910: VideoOpen240910Ru,
    VideoOpen240911: VideoOpen240911Ru,
    VideoOpen240912: VideoOpen240912Ru,
    VideoOpen240913: VideoOpen240913Ru,
    VideoOpen240914: VideoOpen240914Ru,
    VideoOpen240915: VideoOpen240915Ru,
    VideoOpen240916: VideoOpen240916Ru,
    VideoOpen240917: VideoOpen240917Ru,
    VideoOpen240918: VideoOpen240918Ru,
    VideoOpen240919: VideoOpen240919Ru,    
    VideoOpen240921: VideoOpen240921Ru,    
    VideoOpen240925: VideoOpen240925Ru,
    VideoOpen240926: VideoOpen240926Ru,
    VideoBrillo241009: VideoBrillo241009Ru,
    VideoBrillo241017: VideoBrillo241017Ru,
    VideoBrillo241031: VideoBrillo241031Ru,
    VideoBrillo241114: VideoBrillo241114Ru,
    VideoBrillo241121: VideoBrillo241121Ru,
    VideoBrillo241128: VideoBrillo241128Ru,
    VideoBrillo241205: VideoBrillo241205Ru,
    VideoBrillo241226: VideoBrillo241226Ru,
    VideoWDance250125: VideoWDance250125Ru,
    VideoOpen250418: VideoOpen250418Ru,
    VideoOpen250419: VideoOpen250419Ru,
    VideoOpen250522: VideoOpen250522Ru,
    VideoOpen250523: VideoOpen250523Ru,
    VideoOpen250524: VideoOpen250524Ru,
    VideoTardeo250524: VideoTardeo250524Ru,
    VideoOpen250525: VideoOpen250525Ru,
    VideoOpen250528: VideoOpen250528Ru,
    VideoOpen250529: VideoOpen250529Ru,
    VideoOpen250530: VideoOpen250530Ru,
    VideoOpen250531: VideoOpen250531Ru,
    VideoOpen250601: VideoOpen250601Ru,
    VideoOpen250604: VideoOpen250604Ru,
    VideoOpen250605: VideoOpen250605Ru,
    VideoOpen250606: VideoOpen250606Ru,
    VideoOpen250607: VideoOpen250607Ru,
    VideoOpen250611: VideoOpen250611Ru,
    VideoOpen250612: VideoOpen250612Ru,
    VideoOpen250616: VideoOpen250616Ru,
    VideoOpen250623: VideoOpen250623Ru,
    VideoOpen250625: VideoOpen250625Ru,
    VideoOpen250628: VideoOpen250628Ru,
    VideoOpen250702: VideoOpen250702Ru,
    VideoOpen250703: VideoOpen250703Ru,
    VideoOpen250704: VideoOpen250704Ru,
    VideoOpen250705: VideoOpen250705Ru,
    VideoOpen250706: VideoOpen250706Ru,
    VideoOpen250707: VideoOpen250707Ru,
    VideoOpen250709: VideoOpen250709Ru,
    VideoOpen250710: VideoOpen250710Ru,
    VideoOpen250711: VideoOpen250711Ru,
    VideoOpen250712: VideoOpen250712Ru,
    VideoOpen250713: VideoOpen250713Ru,
    VideoOpen250714: VideoOpen250714Ru,
    VideoOpen250716: VideoOpen250716Ru,
    VideoOpen250717: VideoOpen250717Ru,
    VideoOpen250718: VideoOpen250718Ru,
    VideoOpen250720: VideoOpen250720Ru,
    VideoOpen250721: VideoOpen250721Ru,
    VideoOpen250722: VideoOpen250722Ru,
    VideoOpen250723: VideoOpen250723Ru,
    VideoOpen250725: VideoOpen250725Ru,
    VideoOpen250726: VideoOpen250726Ru,
    VideoOpen250727: VideoOpen250727Ru,
    VideoOpen250728: VideoOpen250728Ru,
    VideoOpen250729: VideoOpen250729Ru,
    VideoOpen250730: VideoOpen250730Ru,
    VideoOpen250731: VideoOpen250731Ru,
    VideoOpen250801: VideoOpen250801Ru,
    VideoOpen250802: VideoOpen250802Ru,
    VideoOpen250803: VideoOpen250803Ru,
    VideoOpen250805: VideoOpen250805Ru,
    VideoOpen250806: VideoOpen250806Ru,
    VideoOpen250807: VideoOpen250807Ru,
    VideoOpen250809: VideoOpen250809Ru,
    VideoOpen250810: VideoOpen250810Ru,
    VideoOpen250813: VideoOpen250813Ru,
    VideoOpen250814: VideoOpen250814Ru,
    VideoOpen250816: VideoOpen250816Ru,
    VideoOpen250817: VideoOpen250817Ru,
    VideoOpen250821: VideoOpen250821Ru,
    VideoOpen250823: VideoOpen250823Ru,
    VideoOpen250824: VideoOpen250824Ru,
    VideoOpen250825: VideoOpen250825Ru,
    VideoOpen250827: VideoOpen250827Ru,
    VideoOpen250828: VideoOpen250828Ru,
    VideoOpen250830: VideoOpen250830Ru,
    VideoOpen250831: VideoOpen250831Ru,
    VideoOpen250901: VideoOpen250901Ru,
    VideoOpen250903: VideoOpen250903Ru,
    VideoOpen250904: VideoOpen250904Ru,
    VideoOpen250906: VideoOpen250906Ru,
    VideoOpen250907: VideoOpen250907Ru,
    VideoOpen250908: VideoOpen250908Ru,
    VideoOpen250910: VideoOpen250910Ru,
    VideoOpen250911: VideoOpen250911Ru,
    VideoOpen250913: VideoOpen250913Ru,
    VideoOpen250914: VideoOpen250914Ru,
    VideoOpen250915: VideoOpen250915Ru,
    VideoOpen250917: VideoOpen250917Ru,
    VideoOpen250920: VideoOpen250920Ru,
    VideoOpen250921: VideoOpen250921Ru,
    VideoOpen250922: VideoOpen250922Ru,
    VideoOpen250928: VideoOpen250928Ru,
    VideoOpen251005: VideoOpen251005Ru,
    VideoOpen251012: VideoOpen251012Ru,
    VideoOpen251019: VideoOpen251019Ru,
    VideoOpen251026: VideoOpen251026Ru,
    VideoOpen251102: VideoOpen251102Ru,
    VideoOpen251109: VideoOpen251109Ru,
    VideoOpen251116: VideoOpen251116Ru,
    VideoOpen251123: VideoOpen251123Ru,
    VideoOpen251130: VideoOpen251130Ru,
    VideoOpen251214: VideoOpen251214Ru,
    VideoOpen251221: VideoOpen251221Ru,
    VideoOpen251228: VideoOpen251228Ru,
    VideoOpen260104: VideoOpen260104Ru,
    VideoOpen260111: VideoOpen260111Ru,
    VideoOpen260118: VideoOpen260118Ru,
    VideoOpen260125: VideoOpen260125Ru,
    VideoOpen260201: VideoOpen260201Ru,
    VideoOpen260215: VideoOpen260215Ru,
    VideoOpen260222: VideoOpen260222Ru,
    VideoOpen260301: VideoOpen260301Ru,
    VideoOpen260308: VideoOpen260308Ru,
    VideoOpen260315: VideoOpen260315Ru,
    VideoOpen260322: VideoOpen260322Ru,
    VideoOpen260329: VideoOpen260329Ru,
    VideoOpen260405: VideoOpen260405Ru,
    VideoOpen260412: VideoOpen260412Ru,
    VideoOpen260419: VideoOpen260419Ru,
    VideoOpen260426: VideoOpen260426Ru,
    VideoOpen260503: VideoOpen260503Ru,
    VideoOpen260506: VideoOpen260506Ru,
    VideoOpen260509: VideoOpen260509Ru,
    VideoOpen260510: VideoOpen260510Ru,
    VideoOpen260512: VideoOpen260512Ru,
    VideoOpen260513: VideoOpen260513Ru,
    VideoOpen260514: VideoOpen260514Ru,
    VideoOpen260516: VideoOpen260516Ru,
    VideoOpen260517: VideoOpen260517Ru,
    VideoOpen260518: VideoOpen260518Ru,
    VideoOpen260519: VideoOpen260519Ru,
    VideoOpen260520: VideoOpen260520Ru,
    VideoOpen260521: VideoOpen260521Ru,
    VideoOpen260522: VideoOpen260522Ru,
    VideoOpen260523: VideoOpen260523Ru,
    VideoOpen260524: VideoOpen260524Ru,
    VideoOpen260530: VideoOpen260530Ru,
    VideoOpen260531: VideoOpen260531Ru,
    VideoOpen260601: VideoOpen260601Ru,
    VideoOpen260602: VideoOpen260602Ru,
    VideoOpen260603: VideoOpen260603Ru,
    VideoOpen260604: VideoOpen260604Ru,
    VideoOpen260605: VideoOpen260605Ru,
    VideoOpen260606: VideoOpen260606Ru,
    VideoOpen260607: VideoOpen260607Ru,
    VideoOpen260608: VideoOpen260608Ru,
    VideoOpen260609: VideoOpen260609Ru,
    VideoOpen260610: VideoOpen260610Ru,
    VideoOpen260611: VideoOpen260611Ru,
    VideoOpen260612: VideoOpen260612Ru,
    VideoOpen260614: VideoOpen260614Ru,
    VideoOpen260617: VideoOpen260617Ru,
    VideoOpen260620: VideoOpen260620Ru,
    VideoOpen260621: VideoOpen260621Ru,
    VideoOpen260622: VideoOpen260622Ru,
    VideoOpen260623: VideoOpen260623Ru,
    VideoOpen260624: VideoOpen260624Ru,
    VideoOpen260625: VideoOpen260625Ru,
    VideoOpen260626: VideoOpen260626Ru,
    VideoOpen260627: VideoOpen260627Ru,
    VideoOpen260628: VideoOpen260628Ru,
    VideoOpen260629: VideoOpen260629Ru,
    VideoOpen260701: VideoOpen260701Ru,
    VideoOpen260702: VideoOpen260702Ru,
    VideoOpen260703: VideoOpen260703Ru,
    VideoOpen260704: VideoOpen260704Ru,
    VideoOpen260705: VideoOpen260705Ru,
    VideoOpen260706: VideoOpen260706Ru,
    VideoOpen260708: VideoOpen260708Ru,
    VideoOpen260709: VideoOpen260709Ru,
    VideoOpen260710: VideoOpen260710Ru,
    VideoOpen260711: VideoOpen260711Ru,
    VideoOpen260713: VideoOpen260713Ru,
    VideoOpen260714: VideoOpen260714Ru,
    VideoOpen260715: VideoOpen260715Ru,
    VideoOpen260716: VideoOpen260716Ru,
    VideoOpen260717: VideoOpen260717Ru,
    VideoOpen260718: VideoOpen260718Ru,
    VideoOpen260719: VideoOpen260719Ru,
    VideoOpen260720: VideoOpen260720Ru,
    VideoOpen260721: VideoOpen260721Ru,
    VideoOpen260722: VideoOpen260722Ru,
    VideoOpen260723: VideoOpen260723Ru,
    VideoOpen260724: VideoOpen260724Ru,
    VideoOpen260725: VideoOpen260725Ru,
    VideoOpen260727: VideoOpen260727Ru,
    VideoOpen260730: VideoOpen260730Ru,
    VideoOpen260731: VideoOpen260731Ru,
    VideoOpen260801: VideoOpen260801Ru,
    VideoOpen260802: VideoOpen260802Ru,
    VideoOpen260803: VideoOpen260803Ru,
    VideoOpen260804: VideoOpen260804Ru,
    VideoOpen260805: VideoOpen260805Ru,
    VideoOpen260806: VideoOpen260806Ru,
    VideoOpen260807: VideoOpen260807Ru,
    VideoOpen260808: VideoOpen260808Ru,
    VideoOpen260809: VideoOpen260809Ru,
    VideoOpen260810: VideoOpen260810Ru,
    VideoOpen260812: VideoOpen260812Ru,
    VideoOpen260814: VideoOpen260814Ru,
    VideoOpen260815: VideoOpen260815Ru,
    VideoOpen260816: VideoOpen260816Ru,
    VideoOpen260817: VideoOpen260817Ru,
    VideoOpen260818: VideoOpen260818Ru,
    VideoOpen260819: VideoOpen260819Ru,
    VideoOpen260820: VideoOpen260820Ru,
    VideoOpen260821: VideoOpen260821Ru,
    VideoOpen260822: VideoOpen260822Ru,
    VideoOpen260823: VideoOpen260823Ru,
    VideoOpen260824: VideoOpen260824Ru,
    VideoOpen260826: VideoOpen260826Ru,
    VideoOpen260827: VideoOpen260827Ru,
    VideoOpen260828: VideoOpen260828Ru,
    VideoOpen260829: VideoOpen260829Ru,
    VideoOpen260831: VideoOpen260831Ru,
    VideoOpen260901: VideoOpen260901Ru,
    VideoOpen260902: VideoOpen260902Ru,
    VideoOpen260903: VideoOpen260903Ru,
    VideoOpen260904: VideoOpen260904Ru,
    VideoOpen260905: VideoOpen260905Ru,
    VideoOpen260909: VideoOpen260909Ru,
    VideoOpen260910: VideoOpen260910Ru,
    VideoOpen260911: VideoOpen260911Ru,
    VideoOpen260912: VideoOpen260912Ru,
    VideoOpen260913: VideoOpen260913Ru,
    VideoOpen260915: VideoOpen260915Ru,
    VideoOpen260916: VideoOpen260916Ru,
    VideoOpen260917: VideoOpen260917Ru,
    VideoOpen260918: VideoOpen260918Ru,
    VideoOpen260919: VideoOpen260919Ru,
    VideoOpen260920: VideoOpen260920Ru,
    VideoOpen260921: VideoOpen260921Ru,
    VideoOpen260926: VideoOpen260926Ru,
    VideoOpen260927: VideoOpen260927Ru,
    VideoOpen261003: VideoOpen261003Ru,
    VideoOpen261004: VideoOpen261004Ru,
    VideoOpen261010: VideoOpen261010Ru,
    VideoOpen261011: VideoOpen261011Ru,
    VideoOpen261016: VideoOpen261016Ru,
    VideoOpen261018: VideoOpen261018Ru,
    VideoOpen261025: VideoOpen261025Ru,
  },
};

export default Constants;

